// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== LAYOUT BASE (Estilo Obras) ==================== */
.veiculos-container-new {
    display: flex;
    flex-direction: column;
    min-height: 100%;
}

/* Page Content - padding after top-bar */
.veiculos-container-new>*:not(.top-bar) {
    padding: 20px 30px;
}

/* ==================== VEHICLES SECTION ==================== */
.vehicles-section {
    background: transparent;
    padding: 0;
    margin-bottom: 35px;
}

.vehicles-section h3 {
    margin: 0 0 15px 0;
    font-size: 0.9rem;
    color: #718096;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.vehicles-grid-compact {
    display: grid;
    /* Toda a frota numa linha: as colunas dividem a largura em partes iguais,
       seja qual for o número de viaturas. Abaixo dos 140px por cartão a linha
       passa a deslizar na horizontal em vez de os espremer até não se lerem.

       Colunas todas iguais é o que se quer, e não uma limitação a contornar:
       já se experimentou dar mais largura só ao cartão das alugadas e o que
       saiu foi um cartão destoante ao lado dos outros. */
    /* As colunas são tantas quantos os cartões (o número vem do próprio ecrã,
       em --n-cartoes) e dividem a largura disponível em partes iguais. Assim a
       fila acaba exatamente onde acaba o painel de baixo, seja qual for o
       tamanho do ecrã — e não a meio, como acontecia com a largura fixa.

       O mínimo de 5,1 cm é o que impede que os cartões se espremam: abaixo
       disso a fila deixa de caber e passa a deslizar na horizontal, que é o que
       o overflow aqui em baixo já previa. Num ecrã largo o minmax cresce até
       preencher; o problema antigo do minmax era com grid-auto-columns, onde a
       coluna partia do mínimo e não esticava. Com grid-template-columns e uma
       contagem conhecida, estica. */
    grid-template-columns: repeat(var(--n-cartoes, 8), minmax(5.1cm, 1fr));
    justify-content: stretch;
    /* Em milímetros porque foi assim que o afastamento foi pedido, e porque a
       largura da coluna aqui em cima também é métrica. Eram 10px — 2,65 mm — e
       a fila ficou deliberadamente muito mais apertada do que isso: os cartões
       quase a tocar-se, com o vinco entre eles a chegar para os separar. É
       este o valor a mexer se um dia voltar a parecer apertado ou largo. */
    gap: 2.9mm;
    overflow-x: auto;
    padding-bottom: 4px;
}

.vehicle-card-compact {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    transition: all 0.2s;
    border: 1px solid transparent;
}

.vehicle-card-compact:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
    border-color: #4299e1;
}

.card-header-compact {
    display: flex;
    justify-content: space-between;
    align-items: start;
    margin-bottom: 12px;
}

.card-header-compact strong {
    font-size: 1.1rem;
    color: #2d3748;
    font-weight: 700;
    display: block;
}

.matricula-small {
    display: inline-block;
    background: #edf2f7;
    color: #667eea;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 0.75rem;
    margin-top: 6px;
    font-weight: 600;
}

.card-actions-compact {
    display: flex;
    gap: 8px;
}

.btn-icon-small {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-icon-small:hover {
    background: #ebf8ff;
    border-color: #3182ce;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(49, 130, 206, 0.1);
}

.btn-icon-small.delete:hover {
    background: #fee2e2;
    border-color: #f56565;
}

.card-info-compact {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-top: 12px;
    border-top: 1px solid #edf2f7;
}

.status-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
}

.status-dot.status-valid {
    background: #48bb78;
}

.status-dot.status-warning {
    background: #ed8936;
}

.status-dot.status-expired {
    background: #f56565;
}

.card-info-compact span:not(.status-dot) {
    font-size: 0.85rem;
    color: #718096;
}

/* ==================== TRIPS SECTION ==================== */
.trips-section {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    border: 1px solid #e2e8f0;
}

.trips-header {
    background: white;
    border-bottom: 2px solid #e2e8f0;
    padding: 20px 24px;
}

.trips-header h3 {
    margin: 0;
    font-size: 1.2rem;
    color: #2d3748;
    font-weight: 700;
}

/* Inline Trip Form */
.trip-form-card {
    background: #f8fafc;
    padding: 20px 24px;
    border-bottom: 1px solid #e2e8f0;
}

/* Capture View Container */
.capture-view {
    max-width: 600px;
    margin: 0 auto;
    width: 100%;
}

.capture-card {
    background: white;
    border-radius: 20px;
    padding: 25px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
    border: none;
}

/* Mobile Form Styles */
.mobile-form-group {
    margin-bottom: 20px;
}

.mobile-form-group label {
    display: block;
    font-size: 0.85rem;
    color: #a0aec0;
    margin-bottom: 8px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.mobile-form-input,
.mobile-form-select {
    width: 100%;
    padding: 16px;
    font-size: 1.1rem;
    border: 2px solid #edf2f7;
    border-radius: 12px;
    background: #f7fafc;
    color: #2d3748;
    transition: all 0.2s;
    appearance: none;
}

.mobile-form-input:focus,
.mobile-form-select:focus {
    outline: none;
    border-color: #4299e1;
    background: white;
    box-shadow: 0 0 0 4px rgba(66, 153, 225, 0.1);
}

.btn-large-submit {
    width: 100%;
    padding: 18px;
    background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%);
    color: white;
    border: none;
    border-radius: 16px;
    font-size: 1.1rem;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 8px 15px rgba(49, 130, 206, 0.2);
    transition: transform 0.1s;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}

.btn-large-submit:active {
    transform: scale(0.96);
}

/* Mobile Recent List */
.mobile-recent-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.mobile-recent-item {
    background: white;
    border-radius: 16px;
    padding: 15px;
    margin-bottom: 10px;
    border: 1px solid #edf2f7;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.02);
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.mobile-recent-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.mobile-recent-info h4 {
    margin: 0;
    font-size: 0.95rem;
    color: #2d3748;
    font-weight: 700;
}

.mobile-recent-meta {
    font-size: 0.8rem;
    color: #718096;
    margin-top: 2px;
}

.mobile-recent-value {
    font-weight: 700;
    color: #3182ce;
    font-size: 1rem;
    background: #ebf8ff;
    padding: 4px 10px;
    border-radius: 8px;
}

.mobile-recent-actions {
    display: flex;
    gap: 8px;
    border-top: 1px solid #f7fafc;
    padding-top: 10px;
}

.btn-mobile-action {
    flex: 1 1;
    padding: 8px;
    border-radius: 8px;
    border: none;
    font-weight: 600;
    font-size: 0.9rem;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

.btn-mobile-action.delete {
    background: #fff5f5;
    color: #e53e3e;
    border: 1px solid #fed7d7;
}

.trip-form-inline {
    display: grid;
    grid-template-columns: 140px 200px 160px 100px 130px 1fr auto;
    gap: 15px;
    align-items: end;
}

.form-group-inline {
    display: flex;
    flex-direction: column;
}

.form-group-inline.small {
    max-width: 120px;
}

.form-group-inline label {
    font-size: 0.75rem;
    font-weight: 700;
    color: #4a5568;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.form-group-inline input,
.form-group-inline select {
    padding: 10px 12px;
    border: 1px solid #cbd5e0;
    border-radius: 8px;
    font-size: 0.9rem;
    transition: all 0.2s;
    background: white;
}

.form-group-inline input:focus,
.form-group-inline select:focus {
    outline: none;
    border-color: #4299e1;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.btn-add-trip {
    padding: 10px 20px;
    background: #4299e1;
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 0.9rem;
}

.btn-add-trip:hover {
    background: #3182ce;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(66, 153, 225, 0.3);
}

/* Filters Bar */
.filters-bar {
    display: flex;
    gap: 20px;
    padding: 20px 24px;
    background: white;
    border-bottom: 2px solid #e2e8f0;
    align-items: end;
}

.filter-group {
    display: flex;
    flex-direction: column;
}

.filter-group label {
    font-size: 0.75rem;
    font-weight: 700;
    color: #4a5568;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.filter-group select {
    padding: 8px 12px;
    border: 1px solid #cbd5e0;
    border-radius: 8px;
    min-width: 160px;
    background: white;
    font-size: 0.9rem;
    transition: all 0.2s;
}

.filter-group select:focus {
    outline: none;
    border-color: #4299e1;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.totals-display {
    margin-left: auto;
    display: flex;
    gap: 25px;
    padding: 10px 20px;
    background: #f8fafc;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
}

.totals-display span {
    font-size: 0.9rem;
    color: #2d3748;
    font-weight: 500;
}

.totals-display strong {
    color: #4299e1;
    font-weight: 700;
    margin-right: 6px;
}

/* Trips Table */
.trips-table-container {
    overflow-x: auto;
    max-height: 500px;
    overflow-y: auto;
}

.trips-table {
    width: 100%;
    border-collapse: collapse;
}

.trips-table thead {
    position: sticky;
    top: 0;
    background: #f8fafc;
    z-index: 10;
}

.trips-table th {
    padding: 14px 16px;
    text-align: left;
    font-size: 0.75rem;
    font-weight: 700;
    color: #4a5568;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 2px solid #e2e8f0;
}

.trips-table td {
    padding: 16px;
    border-bottom: 1px solid #edf2f7;
    font-size: 0.9rem;
    color: #2d3748;
}

.trips-table tbody tr {
    transition: background 0.2s;
}

.trips-table tbody tr:hover {
    background: #f8fafc;
}

.matricula-tag {
    display: inline-block;
    background: #edf2f7;
    color: #667eea;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 0.75rem;
    margin-left: 8px;
    font-weight: 600;
}

.empresa-tag {
    display: inline-block;
    background: #4299e1;
    color: white;
    padding: 5px 14px;
    border-radius: 16px;
    font-size: 0.8rem;
    font-weight: 600;
}

.btn-icon-delete {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-icon-delete:hover {
    background: #fee2e2;
    border-color: #f56565;
    transform: translateY(-2px);
}

/* ==================== MODALS ==================== */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1100;
}

.modal-content {
    background: white;
    padding: 0;
    border-radius: 12px;
    max-width: 600px;
    width: 90%;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px;
    border-bottom: 2px solid #e2e8f0;
    background: white;
}

.modal-header h2 {
    margin: 0;
    font-size: 1.4rem;
    color: #2d3748;
    font-weight: 700;
}

.close-btn {
    background: #f1f5f9;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    font-size: 1.5rem;
    cursor: pointer;
    color: #4a5568;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.close-btn:hover {
    background: #e2e8f0;
    color: #2d3748;
}

.modal-content form {
    padding: 24px;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 700;
    color: #2d3748;
    font-size: 0.9rem;
}

.form-group input,
.form-group select,
.form-group textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #cbd5e0;
    border-radius: 8px;
    font-size: 0.95rem;
    transition: all 0.2s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
    outline: none;
    border-color: #4299e1;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

.modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #e2e8f0;
}

/* ==================== BUTTONS ==================== */
.btn-primary,
.btn-secondary {
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 0.9rem;
}

.btn-primary {
    background: #4299e1;
    color: white;
}

.btn-primary:hover {
    background: #3182ce;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(66, 153, 225, 0.3);
}

.btn-secondary {
    background: #e2e8f0;
    color: #2d3748;
}

.btn-secondary:hover {
    background: #cbd5e0;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 1024px) {
    .trip-form-inline {
        grid-template-columns: 1fr 1fr;
    }

    .btn-add-trip {
        grid-column: 1 / -1;
    }

    .vehicles-grid-compact { grid-template-columns: repeat(var(--n-cartoes, 8), minmax(5.1cm, 1fr)); }
}

@media (max-width: 768px) {
    .mobile-hide {
        display: none !important;
    }

    .veiculos-container-new>*:not(.top-bar) {
        padding: 0 15px 15px 15px;
        /* No top padding */
    }

    .top-bar {
        padding: 10px 15px;
    }

    .top-bar h1 {
        font-size: 1.1rem;
    }

    .vehicles-grid-compact { grid-template-columns: repeat(var(--n-cartoes, 8), minmax(150px, 1fr)); }

    .trip-form-inline {
        grid-template-columns: 1fr;
    }

    .filters-bar {
        flex-direction: column;
        align-items: stretch;
    }

    .filter-group select {
        width: 100%;
    }

    .totals-display {
        margin-left: 0;
        flex-direction: column;
        gap: 10px;
    }
}
/* ============================================================
   CARTÃO DE VIATURA — a fotografia primeiro

   Antes era uma linha de texto com o nome e a matrícula lado a lado. Numa
   frota pequena reconhece-se a carrinha pela imagem muito antes de se ler a
   matrícula, por isso a fotografia passou a mandar no cartão, com a marca e
   modelo por baixo e a matrícula a seguir, tratada como chapa.
   ============================================================ */
.vehicle-card {
    position: relative;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
    cursor: pointer;                 /* o cartão inteiro abre a edição */
    transition: box-shadow .15s, border-color .15s;
}
.vehicle-card:hover { border-color: #cbd5e1; box-shadow: 0 3px 10px rgba(15, 23, 42, .08); }
.vehicle-card:focus-visible { outline: 2px solid #3182ce; outline-offset: 2px; }

.vehicle-foto {
    position: relative;
    /* Um pouco mais alta do que a média das proporções da frota (1.65), para
       o nome e a chapa assentarem mais abaixo no cartão. As viaturas aparecem
       inteiras à mesma — a fotografia encaixa dentro da moldura, não é
       cortada.

       O min-height e o overflow não são enfeite: sem eles a proporção cede
       perante o conteúdo, e uma fotografia mais alta do que 1.65 estica a caixa
       em vez de ser ela a encolher. Era isso que punha os cartões do Cabstar,
       do Movano e de uma das Ducato mais altos do que os restantes. */
    aspect-ratio: 1.5;
    min-height: 0;
    overflow: hidden;
    background: #f1f5f9;
    display: grid;
    place-items: center;
    color: #94a3b8;                 /* dá a cor ao desenho por omissão */
    border-bottom: 1px solid #e2e8f0;
}
/* contain e não cover: as viaturas têm feitios muito diferentes e o cover
   cortava-lhes as pontas para encher o quadro. */
.vehicle-foto img { width: 100%; height: 100%; object-fit: contain; display: block; }

/* A fotografia gere-se na janela de edição, não por cima do cartão. A imagem
   em si mostra-se no cabeçalho; aqui ficam só os botões que agem sobre ela. */
.modal-foto-btns { display: flex; gap: 8px; align-items: flex-start; }
.btn-foto-modal { cursor: pointer; margin: 0; }

.vehicle-corpo { padding: 8px 7px 9px; text-align: center; }
.vehicle-nome {
    /* Altura de duas linhas mesmo quando só ocupa uma: um nome que parta ao
       meio deslocava a chapa e tudo o que vem por baixo só nesse cartão. */
    display: flex; align-items: center; justify-content: center;
    min-height: 2.4em;
    font-size: 0.8rem; font-weight: 700; color: #1e293b;
    line-height: 1.2; margin-bottom: 6px;
}

/* Chapa de matrícula a sério, em vez de uma etiqueta com ar de chapa. */
.chapa {
    display: inline-flex; align-items: stretch; overflow: hidden;
    /* Medidas tiradas da chapa real: largura ~4,6x a altura, caracteres a
       ocupar ~70% da altura, banda da UE ~9% da largura e moldura preta. */
    height: 21px; border-radius: 3px;
    border: 1px solid #1c1c1c;
    background: linear-gradient(#fdfdfc, #efefec);
    box-shadow: 0 1px 2px rgba(15, 23, 42, .22);
}
/* O azul vem do CSS e não só do <rect>: o viewBox (22x48) não tem a mesma
   proporção da caixa, por isso o browser encaixa o desenho e deixa uma calha
   de cada lado. Com o fundo aqui, a calha também fica azul. */
.chapa-ue { display: block; width: 9px; height: 100%; flex: none; background: #003399; }
.chapa-num {
    display: flex; align-items: center; padding: 0 4px 0 3px;
    /* Na chapa portuguesa os algarismos são ovais altos e estreitos: a largura
       de cada um dá pouco menos de metade da altura das maiúsculas. Daí uma
       condensada — uma fonte larga faria a chapa crescer para o dobro. */
    font-family: "Arial Narrow", "Helvetica Neue Condensed", "Roboto Condensed", Arial, sans-serif;
    font-stretch: condensed;
    font-size: 1.15rem; font-weight: 700; letter-spacing: .06em;
    line-height: 1; color: #1a1a1a; white-space: nowrap;
}
/* Entre grupos vai um quadrado, não um ponto redondo. Sem margem à esquerda:
   o letter-spacing do último caractere do grupo já abre esse espaço. */
.chapa-sep {
    flex: none; align-self: center;
    width: 2px; height: 2px; border-radius: .5px;
    background: currentColor;
    margin: 0 2px 0 0;
}
.vehicle-acoes {
    position: absolute; bottom: 8px; right: 8px; display: flex; gap: 3px;
    opacity: 0; transition: opacity .15s;
}
.vehicle-card:hover .vehicle-acoes,
.vehicle-acoes:focus-within { opacity: 1; }

/* ============================================================
   CABEÇALHO DA JANELA DE EDIÇÃO

   Em vez do título "Editar Veículo", a própria viatura: fotografia, marca e
   modelo, e a chapa. Quem abre a janela vê logo em qual está a mexer, sem ter
   de ler a matrícula num campo de texto.
   ============================================================ */
.modal-header-viatura {
    align-items: flex-start;
    /* 10px em cima para a carrinha não encostar ao topo. Em baixo só o
       necessário para a chapa não colar à linha divisória — e é aí que os
       campos ganham altura, porque sobem com ela. */
    padding: 10px 24px 20px;
}
/* O formulário encostava-se à chapa com 24px por cima, o que abria um vão
   grande entre a matrícula e o primeiro campo. */
/* A linha divisória desceu 6px (padding do cabeçalho), mas os campos ficam onde
   estavam: esta margem negativa devolve-lhes exatamente esses 6px. Sem ela, os
   campos desciam atrás da linha. */
.modal-content .modal-header-viatura + form { padding-top: 0; margin-top: -6px; }

/* Os campos desta janela são poucos e curtos: os 20px de intervalo herdados
   deixavam-nos a boiar. Presos à classe da janela para não mexer nas outras. */
.modal-content-viatura .form-group { margin-bottom: 8px; }
/* Quem separa as duas linhas de campos é este valor. */
.modal-content-viatura .linha-seguro .form-group { margin-bottom: 12px; }
.modal-content-viatura .linha-seguro { margin-bottom: 0; }
.modal-viatura {
    flex: 1 1;
    display: flex; flex-direction: column; align-items: center;
    text-align: center;
    gap: 3px;
}
.modal-viatura-foto {
    /* Mesma proporção do cartão, pela mesma razão: a frota tem feitios
       diferentes e o quadro tem de servir a todos. */
    width: 250px; max-width: 100%; aspect-ratio: 1.65;
    display: grid; place-items: center; overflow: hidden;
    /* Sem fundo nem moldura: a fotografia é um PNG recortado, e assim a
       viatura assenta na janela em vez de ficar dentro de uma caixa. */
    background: transparent; color: #94a3b8;
}
/* contain e não cover: sem fundo por trás, um recorte cortado nas pontas ficava
   a flutuar mal. Assim a viatura aparece inteira. */
.modal-viatura-foto img { width: 100%; height: 100%; object-fit: contain; display: block; }
.modal-viatura-nome {
    font-size: 1.05rem; font-weight: 700; color: #1e293b; line-height: 1.25;
}

.modal-foto-btns-linha { flex-wrap: wrap; }

/* Companhia, apólice e validade do seguro lado a lado. A companhia leva 1.4
   porque "Generali Tranquilidade" é bem mais comprido do que um número de
   apólice ou uma data; abaixo dos 520px o telemóvel empilha-os. */
/* Esta janela é mais larga do que as outras: são três campos na mesma linha e
   a companhia de seguros precisa de espaço.

   O seletor leva o .modal-overlay à frente por necessidade, não por gosto: o
   Utilizadores.css também declara .modal-content, com max-width 500px, e o CSS
   aqui é global. Com a mesma especificidade ganhava a regra que viesse depois
   no pacote — e vinha a dos Utilizadores, que prendia esta janela nos 500px. */
.modal-overlay .modal-content-viatura {
    max-width: 480px;
    /* O padding também tem de vir daqui: o Utilizadores.css declara
       .modal-content com padding 30px e ganhava ao padding 0 deste ficheiro,
       o que punha 30px de vazio por cima da carrinha. */
    padding: 0;
}

.linha-seguro {
    display: grid;
    /* Larguras fixas e medidas, não proporções. Os 165px da seguradora são uma
       escolha do Tiago, abaixo dos 177px que "Generali Tranquilidade" pede por
       campo. 136px é o mínimo de um campo de data: dd/mm/aaaa ocupa 88px (mais
       do que uma data preenchida, por causa das letras), o ícone do calendário
       17px, e as margens internas 26px. A seguradora leva a mesma medida. */
    grid-template-columns: 136px 132px 136px;
    justify-content: center;
    gap: 14px;
    /* As caixas alinham-se pela base. Sem isto, um título que se parta em duas
       linhas — "Companhia Seguros" numa coluna estreita — empurrava a sua caixa
       para baixo e desalinhava a linha toda. */
    align-items: end;
}
/* A MESMA grelha da linha de cima, e não uma grelha de duas colunas: só assim
   as caixas caem debaixo da Seguradora e da Apólice. Uma grelha própria, ainda
   que centrada, começaria noutro sítio. A terceira coluna fica vazia. */
.linha-inspecao {
    display: grid;
    grid-template-columns: 136px 132px 136px;
    justify-content: center;
    gap: 14px;
}
@media (max-width: 620px) {
    .linha-seguro, .linha-inspecao { grid-template-columns: 136px; }
}

/* Títulos e valores ao centro, cada título por cima do seu campo.

   Preso a .modal-content-viatura e não a .modal-content: o CSS aqui é global e
   .modal-content também é usado nas janelas dos Utilizadores e do Detalhe de
   Obra, que não têm nada que ver com isto. */
.modal-content-viatura .form-group label {
    text-align: center;
    margin-bottom: 0;
    /* O intervalo por omissão da linha deixa uma folga por cima do texto que
       aqui não serve para nada e afastava a segunda linha da primeira. */
    line-height: 1.15;
}
.modal-content-viatura .form-group input,
.modal-content-viatura .form-group select {
    text-align: center;
    /* Altura fixa e igual para todos. O navegador desenha um campo de data com
       altura ligeiramente diferente de um campo de texto, e como as caixas se
       alinham pela base, essa diferença aparecia em cima: o título "Validade
       Seguro" ficava mais alto do que os outros dois. */
    box-sizing: border-box;
    height: 42px;
}
/* A data fica à esquerda. Centrá-la obrigava a compensar o ícone do calendário
   com margem do lado esquerdo, e essa margem roubava a largura de que a própria
   data precisava — 20/01/2026 aparecia cortado. */
.modal-content-viatura .form-group input[type="date"] {
    text-align: left;
    padding-left: 12px;
}

/* ============================================================
   LEITURAS DO CONTA-QUILÓMETROS
   ============================================================ */
/* Cada viatura é o cartão mais o botão, empilhados. O botão fica fora do
   cartão de propósito: assim não tem de travar o clique que abre a edição. */
.vehicle-item {
    display: flex; flex-direction: column;
    /* Sem isto, as colunas não ficam todas do mesmo tamanho: os botões e as
       etiquetas têm white-space: nowrap, e um item de grelha recusa-se a
       encolher abaixo do seu conteúdo mínimo. A coluna crescia, e como a altura
       da fotografia sai da largura, esse cartão ficava mais alto do que os
       outros. */
    min-width: 0;
}

.btn-kms {
    width: 100%; margin-top: 6px;
    padding: 7px 4px;
    border: 1px solid #cbd5e0; border-radius: 7px;
    background: #e2e8f0; color: #334155;
    font-size: 0.84rem; font-weight: 600; cursor: pointer;
    white-space: nowrap;
    transition: background .15s, border-color .15s;
}
.btn-kms:hover { background: #cbd5e1; border-color: #94a3b8; }
.btn-kms:focus-visible { outline: 2px solid #3182ce; outline-offset: 1px; }

/* Fica por cima da janela da viatura, que continua aberta por baixo. */
.modal-kms-overlay { z-index: 3000; }
.modal-overlay .modal-kms {
    /* Mais larga do que as outras: leva tabelas com descrições de eventos, que
       são texto livre e não cabem numa coluna estreita. */
    max-width: 720px;
    padding: 0;
}
.modal-kms .kms-form { padding: 4px 24px 14px; }
.kms-form {
    display: grid;
    /* Larguras à medida e o conjunto ao centro, em vez de a segunda coluna
       esticar até ao fim da janela. */
    grid-template-columns: 150px 150px auto;
    justify-content: center;
    gap: 12px;
    align-items: end;
    padding: 8px 24px 14px;
}
.kms-form .form-group { margin-bottom: 0; }
/* Título por cima do seu campo, e o valor ao centro da caixa. */
.modal-kms .form-group label { text-align: center; margin-bottom: 4px; }
.modal-kms .form-group input { text-align: center; box-sizing: border-box; height: 42px; }
/* A data leva o ícone do calendário à direita: centrá-la roubava-lhe a largura
   de que precisa, e dd/mm/aaaa aparecia cortado. */
.modal-kms .form-group input[type="date"] { text-align: left; }
.kms-registar { height: 42px; white-space: nowrap; }

.kms-erro, .kms-aviso {
    margin: 0 24px 12px; padding: 9px 12px;
    border-radius: 8px; font-size: 0.85rem;
}
.kms-erro { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }
.kms-aviso { background: #fffbeb; color: #92400e; border: 1px solid #fde68a; }

.kms-historico { padding: 0 24px 20px; max-height: 320px; overflow-y: auto; }
.kms-vazio { margin: 6px 0 0; color: #64748b; font-size: 0.86rem; }
/* separate e não collapse: com as bordas colapsadas o navegador ignora o
   border-radius das células, e o retângulo do total ficava de pontas vivas. O
   espaçamento a zero mantém o aspeto de tabela colapsada. */
.kms-tabela { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 0.86rem; }
.kms-tabela th {
    text-align: center; padding: 6px 8px;
    color: #64748b; font-weight: 600; font-size: 0.76rem;
    border-bottom: 1px solid #e2e8f0;
    position: sticky; top: 0; background: #fff;
}
/* Valores ao centro, como os títulos. As exceções são a ocorrência, que é texto
   corrido e se lê melhor encostada à esquerda, e o montante, que tem de alinhar
   pela vírgula. */
.kms-tabela td { padding: 7px 8px; border-bottom: 1px solid #f1f5f9; color: #1e293b; text-align: center; }
.kms-tabela td.col-texto { text-align: left; }
.kms-tabela tr:last-child td { border-bottom: none; }
/* Um conta-quilómetros não anda para trás: se aparecer, é engano a assinalar. */
.kms-negativo { color: #b91c1c; font-weight: 700; }

/* Resumo do período, por cima da lista. */
.kms-resumo {
    display: grid;
    /* Os quatro na mesma linha; em ecrã estreito partem para duas. */
    grid-template-columns: repeat(4, 1fr);
    gap: 10px 16px;
    margin: 0 24px 14px;
    padding: 12px 14px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    text-align: center;
}
.kms-resumo div {
    display: flex; flex-direction: column; align-items: center; gap: 2px;
}
.kms-resumo span {
    font-size: 0.72rem; color: #64748b; line-height: 1.25;
    /* Altura de duas linhas mesmo nos títulos de uma só: sem isto, o valor de
       "Percorridos no período" ficava uma linha abaixo dos restantes. */
    min-height: 2.1em;
}
.kms-resumo strong { font-size: 0.86rem; color: #1e293b; }
@media (max-width: 620px) {
    .kms-resumo { grid-template-columns: repeat(2, 1fr); }
}

/* Título ao centro da janela, e não do espaço que sobra ao lado do X. Com o
   botão de fechar tirado do fluxo, o título centra-se na largura toda; a
   margem lateral impede que um nome comprido lhe passe por baixo. */
/* 4px por cima do título e 4px por baixo dele: a linha divisória continua com o
   mesmo ar dos dois lados, e todo o bloco sobe. */
.modal-kms .modal-header { position: relative; justify-content: center; padding: 4px 24px; }
.modal-kms .modal-header h2 { margin: 0; text-align: center; padding: 0 40px; }
.modal-kms .modal-header .close-btn {
    position: absolute; right: 24px; top: 50%;
    transform: translateY(-50%);
}

/* Botões do rodapé com a mesma largura e ao centro. Os 180px vêm do rótulo
   mais comprido — "Guardar Alterações" pede 179px com as margens internas —
   para que "Cancelar" fique do mesmo tamanho sem apertar o outro. */
.modal-content-viatura .modal-footer {
    justify-content: center;
    gap: 10px;
}
.modal-content-viatura .modal-footer button {
    min-width: 180px;
    height: 42px;
    box-sizing: border-box;
    /* Centragem declarada e não herdada: com altura fixa e o padding assimétrico
       que estes botões trazem, o texto não assentava ao meio sozinho. */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 16px;
}

/* Campo que mostra um valor calculado noutro sítio: sem moldura de campo
   editável, para não convidar a escrever nele. */
.modal-content-viatura .campo-so-leitura {
    background: #f8fafc;
    color: #475569;
    cursor: default;
}

/* Resumo por baixo dos botões. Duas colunas por linha — etiqueta à esquerda,
   valor à direita — para se ler em varrimento vertical. */
.vehicle-resumo {
    /* De volta ao fundo do cartão. Só é possível ter ao mesmo tempo os títulos
       alinhados e os cartões a fechar rentes porque o bloco tem agora sempre a
       mesma altura: as linhas do "ou" e da data existem em todos, invisíveis
       quando não há data. */
    margin: auto 0 0;
    padding: 7px 7px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 7px;
    font-size: 0.74rem;

    /* UMA grelha para as três linhas, e não uma grelha por linha: só assim as
       etiquetas e os valores partilham as mesmas colunas. Com uma grelha por
       linha, a coluna da etiqueta ajustava-se ao comprimento da sua palavra e
       "Inspeção:" empurrava o seu valor mais para a direita do que "Seguro:". */
    display: grid;
    /* Colunas do tamanho do que levam dentro, e o par encostado à esquerda. O
       "1fr" na segunda coluna está fora de questão: ela comia toda a largura
       que sobrava e o bloco ia esparramar-se até à direita. O que sobra fica
       todo do lado direito, de propósito — as etiquetas é que mandam no eixo. */
    grid-template-columns: auto auto;
    justify-content: start;
    gap: 0 5px;
    align-items: baseline;
}
/* O cartão das alugadas não tem os três botões por cima do resumo, e por isso
   o retângulo faz sozinho o caminho que nos outros é dos botões e do resumo:
   começa aos mesmos 6px do .btn-kms, à altura do "Registar kms" dos vizinhos,
   e cresce até fechar rente ao resumo deles em baixo.

   O crescer é do flex-grow, não de uma altura escrita à mão — assim acompanha
   os vizinhos se um dia lá aparecer mais uma linha ou outro botão. E é o
   flex-grow e não o "flex: 1": com a base a zero o retângulo podia encolher
   abaixo do que leva dentro e deixar o texto a sair fora.

   Dentro é uma lista de viaturas e não os pares etiqueta/valor da grelha de
   cima: o mês à cabeça e, por baixo, cada alugada com a chapa e o consumo a
   que andou. Tudo encostado ao topo, logo a seguir ao filtro — ao centro, as
   viaturas descolavam-se dele e ficavam a boiar no meio do retângulo.

   O min-height com o overflow é para o dia em que houver alugadas a mais para
   a altura disponível: sem eles, era este cartão a esticar e a puxar a fila
   toda atrás dele, que é precisamente o que a altura igual evita. */
.vehicle-resumo.resumo-alugadas {
    margin: 6px 0 0;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    /* Tem de estar escrito: a regra de cima alinha pela baseline, o que serve
       os pares etiqueta/valor mas aqui deixava cada linha com a largura do que
       tem dentro em vez da largura do cartão. Era o que fazia os doze meses
       acabarem a meio, com o resto do retângulo em branco à direita. */
    align-items: stretch;
    gap: 10px;
    min-height: 0;
    overflow-y: auto;
}

/* O ano numa caixa e os doze meses numa grelha por baixo. Os meses são botões
   soltos e não um <select multiple>: escolher meses separados num select
   obriga a arrastar com a tecla de controlo carregada, e num espaço destes o
   painel nem se lê. Assim vê-se de relance o que está escolhido. */
.alugadas-filtro { display: flex; flex-direction: column; gap: 5px; margin-bottom: 2px; }
.alugadas-filtro select {
    width: 100%; min-width: 0;
    padding: 2px 3px;
    /* O text-align-last vai junto: há browsers que ignoram o text-align na
       linha escolhida de um <select> e deixavam o ano encostado à esquerda. */
    text-align: center; text-align-last: center;
    font-size: 0.68rem; font-family: inherit; color: #334155;
    background: #f8fafc;
    border: 1px solid #cbd5e0; border-radius: 5px;
    cursor: pointer;
}
.alugadas-filtro select:focus-visible { outline: 2px solid #3182ce; outline-offset: 1px; }

/* Os doze numa só linha, por número, a repartir a largura toda do cartão em
   partes iguais. Cada casa fica com uns 14px, o que só dá para dois algarismos
   apertados — daí o gap de 1px, o padding lateral a zero e a letra mais
   pequena do que a do resto do cartão. Quem precisar do nome do mês tem-no no
   title.

   O minmax(0, 1fr) e não 1fr à seca: um "1fr" não deixa a casa encolher abaixo
   do que leva dentro, e as três de dois algarismos ficavam mais largas do que
   as outras nove. Com o mínimo a zero, as doze medem todas o mesmo. */
.alugadas-meses { display: grid; grid-template-columns: repeat(12, minmax(0, 1fr)); gap: 1px; }
.alugadas-mes {
    padding: 2px 0;
    font-size: 0.58rem; font-weight: 600; font-family: inherit;
    color: #475569; background: #f8fafc;
    border: 1px solid #cbd5e0; border-radius: 3px;
    cursor: pointer;
    transition: background .12s, border-color .12s, color .12s;
}
.alugadas-mes:hover { background: #e2e8f0; border-color: #94a3b8; }
.alugadas-mes.on { background: #1e40af; border-color: #1e40af; color: #fff; }
.alugadas-mes.on:hover { background: #1d4ed8; }
.alugadas-mes:focus-visible { outline: 2px solid #3182ce; outline-offset: 1px; }
/* Desfaz o "display: contents" da regra aqui em baixo, que dissolvia estas
   linhas na grelha do pai — grelha que este retângulo já não usa. */
.vehicle-resumo.resumo-alugadas > div { display: block; }

/* O que desliza é a lista, não o retângulo todo: o ano e os meses ficam à
   vista sempre, senão quem desce para ver a quarta viatura perde de vista o
   período a que os números dizem respeito.

   250px dão quase quatro linhas — a partir daí desliza. É o espaço que o
   retângulo tem hoje por baixo do filtro; passar disso empurrava o cartão
   para baixo dos outros. */
.alugadas-lista {
    max-height: 250px;
    overflow-y: auto;
    overscroll-behavior: contain;
    min-height: 0;
}

.alugada-linha { text-align: center; }
.alugada-linha + .alugada-linha { border-top: 1px solid #f1f5f9; padding-top: 10px; }
/* A matrícula em texto, a fazer de título da linha. Sem moldura nem fundo: é
   um botão pelo que faz, não pelo que parece. */
.alugada-chapa {
    display: block; margin: 0 auto;
    border: none; background: none; padding: 0; cursor: pointer;
    font: inherit; font-weight: 800; font-size: 0.78rem;
    color: #1e293b; letter-spacing: .06em;
}
.alugada-chapa:hover { color: #2b6cb0; }
.alugada-chapa:focus-visible { outline: 2px solid #3182ce; outline-offset: 2px; border-radius: 4px; }
.alugada-media {
    display: block; margin-top: 3px;
    color: #64748b;
    line-height: 1.35;
}
/* Uma linha para os quilómetros, outra para a média. Cada uma inteira, sem se
   partir a meio de um número — num cartão de 5,4 cm as duas juntas na mesma
   linha ficavam cortadas à direita. */
.alugada-parte { display: block; white-space: nowrap; }
.alugada-sem { color: #94a3b8; font-weight: 600; }
.alugadas-vazio { margin: 0; text-align: center; color: #94a3b8; }
/* O abastecimento que ainda não fechou consumo: informação, não alarme. */
.alugada-solto { color: #b45309; font-size: 0.72rem; line-height: 1.3; }

/* As linhas deixam de ser caixas próprias e os seus dois campos passam a ser
   itens da grelha de cima. */
.vehicle-resumo > div { display: contents; }
/* Duas colunas em vez de flex com espaço no meio: assim as etiquetas encostam
   todas ao mesmo eixo e os valores ficam centrados na coluna deles. */
/* O traço separador vai nas células, já que as linhas deixaram de existir
   como caixa. */
.vehicle-resumo > div + div > dt,
.vehicle-resumo > div + div > dd { border-top: 1px solid #f1f5f9; }
.vehicle-resumo dt, .vehicle-resumo dd { padding: 2px 0; }
.vehicle-resumo dt { color: #64748b; white-space: nowrap; text-align: right; }
.vehicle-resumo dd {
    margin: 0; color: #1e293b; font-weight: 600;
    text-align: center;
    /* Sem isto o valor podia partir-se em qualquer letra, e a grelha usava
       essa liberdade para dar mais largura à coluna das etiquetas: "16/02/2027"
       aparecia em duas linhas com o cartão a 5 cm. Proibida a quebra, é a
       coluna da etiqueta que cede. */
    white-space: nowrap;
}

/* Prazo a um mês ou menos, ou revisão a 2500 km ou menos: fundo vermelho e
   letra branca. O realce fica no valor e não na célula toda, para se perceber
   que é aquele dado que está em risco. */
/* Ocupa a largura toda da coluna do valor: com inline-block, cada etiqueta
   ficava do tamanho do seu próprio texto e as três apareciam com larguras
   diferentes umas por baixo das outras. */
.prazo-alerta {
    display: block;
    background: #dc2626; color: #fff;
    padding: 1px 5px; border-radius: 4px;
    font-weight: 700;
    text-align: center;
}

/* A consulta tem três selectores; o registo de evento tem data, texto e botão. */
.consulta-form { grid-template-columns: 160px 120px 150px; }
/* Os campos numa linha e o botão por baixo, ao centro. */
/* O seletor leva o .modal-kms à frente por necessidade: a regra geral
   ".modal-content form" tem mais força do que uma classe sozinha, e era ela que
   continuava a impor 24px de margem por cima dos campos. */
.modal-kms .evento-form { padding: 4px 24px 14px; }
.evento-campos {
    display: grid;
    /* Data e valor no mínimo que o seu conteúdo exige — 136px para dd/mm/aaaa
       com o calendário, 120px para 100.000,00 € — e tudo o que sobra vai para a
       ocorrência, que é texto livre e nunca tem largura a mais. */
    grid-template-columns: 136px minmax(200px, 1fr) 120px;
    gap: 12px;
    align-items: end;
}
.evento-campos .form-group { margin-bottom: 0; }
.evento-registar {
    margin: 14px auto 0; min-width: 180px; height: 42px;
    /* Centragem declarada: com altura fixa e o padding que estes botões trazem,
       o texto não assentava ao meio sozinho. */
    display: flex; align-items: center; justify-content: center;
    padding: 0 16px;
}

/* Caixa do montante com o símbolo colado à direita, dentro do próprio campo. */
.campo-euro { position: relative; }
.campo-euro input { padding-right: 26px !important; text-align: right !important; }
.campo-euro span {
    position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
    color: #64748b; font-size: 0.9rem; pointer-events: none;
}

/* O valor não deve partir-se nem competir com a descrição pelo espaço. */
.kms-tabela th.col-valor, .kms-tabela td.col-valor { text-align: right; white-space: nowrap; width: 1%; }
.modal-kms .form-group select {
    width: 100%; height: 42px; box-sizing: border-box;
    padding: 0 10px; border: 1px solid #cbd5e0; border-radius: 8px;
    font-size: 0.9rem; background: #fff; color: #1e293b;
}
.modal-kms .form-group select:disabled { background: #f1f5f9; color: #94a3b8; cursor: not-allowed; }
/* A data não deve partir-se em duas linhas por causa de um texto comprido ao lado. */
.kms-tabela td.col-data { white-space: nowrap; width: 1%; }

/* Data ao centro como o seu título; a ocorrência fica à esquerda porque é texto
   corrido, e o valor à direita para os montantes alinharem pela vírgula. */
.kms-tabela td.col-data { text-align: center; }

.kms-tabela td.col-acoes { white-space: nowrap; width: 1%; text-align: right; }
/* O .btn-icon-small é display:flex, o que faz cada botão ocupar a linha toda e
   empilha o lápis por cima do caixote. Aqui ficam lado a lado. */
.kms-tabela td.col-acoes .btn-icon-small { display: inline-flex; vertical-align: middle; }
.kms-tabela td.col-acoes .btn-icon-small + .btn-icon-small { margin-left: 3px; }

/* Caixa de correção do texto, à medida da célula onde nasce. */
.evento-edicao {
    width: 100%; box-sizing: border-box;
    padding: 3px 6px;
    border: 1px solid #3182ce; border-radius: 5px;
    font-size: 0.86rem; color: #1e293b;
}

/* Total do período, na última linha da consulta de eventos. Traço preto a
   separá-la das restantes, e o texto assente numa etiqueta de vermelho
   esbatido — o vermelho aqui assinala, não dá alarme. */
.kms-tabela tfoot .linha-total td {
    border-top: 2px solid #1e293b;
    padding-top: 9px;
    color: #0f172a;
    font-weight: 700;
}
/* O vermelho cobre a linha toda, da primeira célula à última, como um só
   retângulo com as pontas arredondadas nas extremidades. */
.kms-tabela tfoot .linha-total td { background: #fee2e2; }
.kms-tabela tfoot .linha-total td:first-child { border-radius: 6px 0 0 6px; padding-left: 10px; }
.kms-tabela tfoot .linha-total td:last-child { border-radius: 0 6px 6px 0; padding-right: 10px; }
.kms-tabela tfoot .linha-total td:nth-child(2) { text-align: left; }

/* Botão de dar o alerta por tratado. Só aparece enquanto houver vermelho, e
   fica ao lado do valor em vez de numa coluna própria — no cartão estreito não
   há largura para lhe dar um sítio só dela. */
.btn-tratado {
    margin-left: 4px;
    width: 16px; height: 16px;
    padding: 0; border: none; border-radius: 4px;
    background: #16a34a; color: #fff;
    font-size: 0.6rem; line-height: 1;
    cursor: pointer; vertical-align: middle;
}
.btn-tratado:hover { background: #15803d; }
.btn-tratado:focus-visible { outline: 2px solid #1d4ed8; outline-offset: 1px; }


/* Revisão: quilómetros OU data, o que vier primeiro. O "ou" fica entre os dois
   campos para se perceber que são alternativas e não dois prazos a cumprir. */
.form-group .revisao-ou {
    text-align: center; font-size: 11px; font-weight: 700; letter-spacing: 0.06em;
    text-transform: uppercase; color: #94a3b8; margin: 5px 0 4px;
}


/* No cartão, os dois gatilhos da revisão ficam empilhados: o valor, o "ou", e
   a data. Sem tamanho nem cor próprios — herdam do valor, para a coluna ficar
   toda com a mesma letra. */
.vehicle-resumo .revisao-ou-cartao,
.vehicle-resumo .revisao-data { display: block; }

/* Bomba de abastecimento ao lado da ultima media, quando o consumo se afasta
   do normal desta viatura. Fica antes do visto, como o vermelho dos prazos. */
.alerta-consumo { margin-left: 6px; font-size: 0.95rem; line-height: 1; }

/* "11,20 L/100 km" nao pode partir-se ao meio. As datas dos outros alertas sao
   curtas e cabem sempre; este valor e mais largo e, em cartoes estreitos,
   quebrava a meio do numero. */
.vehicle-resumo .prazo-alerta { white-space: nowrap; }

.vehicles-loading { min-height: 310px; display: flex; align-items: center; justify-content: center; gap: 16px; color: #577585; border: 1px solid #ffffffb0; border-radius: 18px; background: #f4f9ff80; }

/* Consumos com a mesma tipografia, mantendo a cor que identifica o desvio. */
html body .app-layout .main-content .veiculo-media-valor {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 13px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-variant-numeric: tabular-nums;
}
html body .app-layout .main-content .veiculo-media-valor.prazo-alerta {
    background: transparent !important;
    color: #ff0000 !important;
    padding: 0;
}

/* Avisos legíveis e discretos, sem fundos vermelhos. */
html body .app-layout .main-content .vehicle-resumo .prazo-alerta {
    background: transparent !important;
    color: #825009 !important;
    padding: 0;
    font-weight: 600;
}

`, "",{"version":3,"sources":["webpack://./src/pages/Veiculos.css"],"names":[],"mappings":"AAAA,yEAAyE;AACzE;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;AACtB;;AAEA,+DAA+D;AAC/D;IACI,uBAAuB;IACvB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb;;;;;;yDAMqD;IACrD;;;;;;;;;;oCAUgC;IAChC,sEAAsE;IACtE,wBAAwB;IACxB;;;;2EAIuE;IACvE,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA,4DAA4D;AAC5D;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,qBAAqB;AACrB;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;IAChB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,2CAA2C;IAC3C,mBAAmB;IACnB,YAAY;AAChB;;AAEA,uBAAuB;AACvB;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IAEpB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,6DAA6D;IAC7D,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,8CAA8C;IAC9C,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,6DAA6D;IAC7D,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA,qDAAqD;AACrD;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA,sDAAsD;AACtD;;IAEI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yDAAyD;AACzD;IACI;QACI,8BAA8B;IAClC;;IAEA;QACI,mBAAmB;IACvB;;IAEA,yBAAyB,sEAAsE,EAAE;AACrG;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,yBAAyB;QACzB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA,yBAAyB,sEAAsE,EAAE;;IAEjG;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;QACd,sBAAsB;QACtB,SAAS;IACb;AACJ;AACA;;;;;;;iEAOiE;AACjE;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe,kBAAkB,mCAAmC;IACpE,8CAA8C;AAClD;AACA,sBAAsB,qBAAqB,EAAE,4CAA4C,EAAE;AAC3F,8BAA8B,0BAA0B,EAAE,mBAAmB,EAAE;;AAE/E;IACI,kBAAkB;IAClB;;;;;;;;sEAQkE;IAClE,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,cAAc,kBAAkB,oCAAoC;IACpE,gCAAgC;AACpC;AACA;iDACiD;AACjD,oBAAoB,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAEpF;8EAC8E;AAC9E,mBAAmB,aAAa,EAAE,QAAQ,EAAE,uBAAuB,EAAE;AACrE,kBAAkB,eAAe,EAAE,SAAS,EAAE;;AAE9C,iBAAiB,oBAAoB,EAAE,kBAAkB,EAAE;AAC3D;IACI;2EACuE;IACvE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,iBAAiB;IACjB,iBAAiB,EAAE,gBAAgB,EAAE,cAAc;IACnD,gBAAgB,EAAE,kBAAkB;AACxC;;AAEA,wEAAwE;AACxE;IACI,oBAAoB,EAAE,oBAAoB,EAAE,gBAAgB;IAC5D;2EACuE;IACvE,YAAY,EAAE,kBAAkB;IAChC,yBAAyB;IACzB,6CAA6C;IAC7C,2CAA2C;AAC/C;AACA;;8DAE8D;AAC9D,YAAY,cAAc,EAAE,UAAU,EAAE,YAAY,EAAE,UAAU,EAAE,mBAAmB,EAAE;AACvF;IACI,aAAa,EAAE,mBAAmB,EAAE,oBAAoB;IACxD;;yEAEqE;IACrE,8FAA8F;IAC9F,uBAAuB;IACvB,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB;IAC3D,cAAc,EAAE,cAAc,EAAE,mBAAmB;AACvD;AACA;uEACuE;AACvE;IACI,UAAU,EAAE,kBAAkB;IAC9B,UAAU,EAAE,WAAW,EAAE,mBAAmB;IAC5C,wBAAwB;IACxB,iBAAiB;AACrB;AACA;IACI,kBAAkB,EAAE,WAAW,EAAE,UAAU,EAAE,aAAa,EAAE,QAAQ;IACpE,UAAU,EAAE,wBAAwB;AACxC;AACA;8BAC8B,UAAU,EAAE;;AAE1C;;;;;;iEAMiE;AACjE;IACI,uBAAuB;IACvB;;oDAEgD;IAChD,uBAAuB;AAC3B;AACA;iDACiD;AACjD;;mCAEmC;AACnC,8CAA8C,cAAc,EAAE,gBAAgB,EAAE;;AAEhF;+EAC+E;AAC/E,qCAAqC,kBAAkB,EAAE;AACzD,uDAAuD;AACvD,mDAAmD,mBAAmB,EAAE;AACxE,uCAAuC,gBAAgB,EAAE;AACzD;IACI,SAAO;IACP,aAAa,EAAE,sBAAsB,EAAE,mBAAmB;IAC1D,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI;qDACiD;IACjD,YAAY,EAAE,eAAe,EAAE,kBAAkB;IACjD,aAAa,EAAE,mBAAmB,EAAE,gBAAgB;IACpD;uEACmE;IACnE,uBAAuB,EAAE,cAAc;AAC3C;AACA;oDACoD;AACpD,0BAA0B,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC1F;IACI,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB;AAC3E;;AAEA,yBAAyB,eAAe,EAAE;;AAE1C;;kEAEkE;AAClE;;;;;;+EAM+E;AAC/E;IACI,gBAAgB;IAChB;;wDAEoD;IACpD,UAAU;AACd;;AAEA;IACI,aAAa;IACb;;;;4EAIwE;IACxE,wCAAwC;IACxC,uBAAuB;IACvB,SAAS;IACT;;+CAE2C;IAC3C,gBAAgB;AACpB;AACA;;wEAEwE;AACxE;IACI,aAAa;IACb,wCAAwC;IACxC,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,iCAAiC,4BAA4B,EAAE;AACnE;;AAEA;;;;6CAI6C;AAC7C;IACI,kBAAkB;IAClB,gBAAgB;IAChB;yEACqE;IACrE,iBAAiB;AACrB;AACA;;IAEI,kBAAkB;IAClB;;;wDAGoD;IACpD,sBAAsB;IACtB,YAAY;AAChB;AACA;;kDAEkD;AAClD;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;iEAEiE;AACjE;6EAC6E;AAC7E;IACI,aAAa,EAAE,sBAAsB;IACrC;;;;gBAIY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW,EAAE,eAAe;IAC5B,gBAAgB;IAChB,yBAAyB,EAAE,kBAAkB;IAC7C,mBAAmB,EAAE,cAAc;IACnC,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;IACrD,mBAAmB;IACnB,8CAA8C;AAClD;AACA,iBAAiB,mBAAmB,EAAE,qBAAqB,EAAE;AAC7D,yBAAyB,0BAA0B,EAAE,mBAAmB,EAAE;;AAE1E,uEAAuE;AACvE,qBAAqB,aAAa,EAAE;AACpC;IACI;0DACsD;IACtD,gBAAgB;IAChB,UAAU;AACd;AACA,uBAAuB,sBAAsB,EAAE;AAC/C;IACI,aAAa;IACb;sCACkC;IAClC,uCAAuC;IACvC,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,sBAAsB;AAC1B;AACA,wBAAwB,gBAAgB,EAAE;AAC1C,gEAAgE;AAChE,+BAA+B,kBAAkB,EAAE,kBAAkB,EAAE;AACvE,+BAA+B,kBAAkB,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACzF;mDACmD;AACnD,4CAA4C,gBAAgB,EAAE;AAC9D,gBAAgB,YAAY,EAAE,mBAAmB,EAAE;;AAEnD;IACI,mBAAmB,EAAE,iBAAiB;IACtC,kBAAkB,EAAE,kBAAkB;AAC1C;AACA,YAAY,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC5E,aAAa,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAE7E,iBAAiB,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC5E,aAAa,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE;AAClE;;4DAE4D;AAC5D,cAAc,WAAW,EAAE,yBAAyB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC7F;IACI,kBAAkB,EAAE,gBAAgB;IACpC,cAAc,EAAE,gBAAgB,EAAE,kBAAkB;IACpD,gCAAgC;IAChC,gBAAgB,EAAE,MAAM,EAAE,gBAAgB;AAC9C;AACA;;kBAEkB;AAClB,iBAAiB,gBAAgB,EAAE,gCAAgC,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACzG,2BAA2B,gBAAgB,EAAE;AAC7C,+BAA+B,mBAAmB,EAAE;AACpD,gFAAgF;AAChF,gBAAgB,cAAc,EAAE,gBAAgB,EAAE;;AAElD,0CAA0C;AAC1C;IACI,aAAa;IACb,iEAAiE;IACjE,qCAAqC;IACrC,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,QAAQ;AACxE;AACA;IACI,kBAAkB,EAAE,cAAc,EAAE,iBAAiB;IACrD;wEACoE;IACpE,iBAAiB;AACrB;AACA,qBAAqB,kBAAkB,EAAE,cAAc,EAAE;AACzD;IACI,cAAc,qCAAqC,EAAE;AACzD;;AAEA;;oEAEoE;AACpE;kDACkD;AAClD,2BAA2B,kBAAkB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE;AAC3F,8BAA8B,SAAS,EAAE,kBAAkB,EAAE,eAAe,EAAE;AAC9E;IACI,kBAAkB,EAAE,WAAW,EAAE,QAAQ;IACzC,2BAA2B;AAC/B;;AAEA;;oEAEoE;AACpE;IACI,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB;wEACoE;IACpE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;iDACiD;AACjD;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;;AAEA;0DAC0D;AAC1D;IACI;;;4BAGwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;;IAElB;;;gFAG4E;IAC5E,aAAa;IACb;;;gFAG4E;IAC5E,gCAAgC;IAChC,sBAAsB;IACtB,UAAU;IACV,qBAAqB;AACzB;AACA;;;;;;;;;;;;;;;;;oEAiBoE;AACpE;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B;;;uEAGmE;IACnE,oBAAoB;IACpB,SAAS;IACT,aAAa;IACb,gBAAgB;AACpB;;AAEA;;;mEAGmE;AACnE,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACxF;IACI,WAAW,EAAE,YAAY;IACzB,gBAAgB;IAChB;8EAC0E;IAC1E,kBAAkB,EAAE,uBAAuB;IAC3C,kBAAkB,EAAE,oBAAoB,EAAE,cAAc;IACxD,mBAAmB;IACnB,yBAAyB,EAAE,kBAAkB;IAC7C,eAAe;AACnB;AACA,wCAAwC,0BAA0B,EAAE,mBAAmB,EAAE;;AAEzF;;;;;;;;sEAQsE;AACtE,kBAAkB,aAAa,EAAE,iDAAiD,EAAE,QAAQ,EAAE;AAC9F;IACI,cAAc;IACd,kBAAkB,EAAE,gBAAgB,EAAE,oBAAoB;IAC1D,cAAc,EAAE,mBAAmB;IACnC,yBAAyB,EAAE,kBAAkB;IAC7C,eAAe;IACf,0DAA0D;AAC9D;AACA,sBAAsB,mBAAmB,EAAE,qBAAqB,EAAE;AAClE,mBAAmB,mBAAmB,EAAE,qBAAqB,EAAE,WAAW,EAAE;AAC5E,yBAAyB,mBAAmB,EAAE;AAC9C,8BAA8B,0BAA0B,EAAE,mBAAmB,EAAE;AAC/E;oEACoE;AACpE,wCAAwC,cAAc,EAAE;;AAExD;;;;;;2BAM2B;AAC3B;IACI,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;IAC5B,aAAa;AACjB;;AAEA,iBAAiB,kBAAkB,EAAE;AACrC,kCAAkC,6BAA6B,EAAE,iBAAiB,EAAE;AACpF;gDACgD;AAChD;IACI,cAAc,EAAE,cAAc;IAC9B,YAAY,EAAE,gBAAgB,EAAE,UAAU,EAAE,eAAe;IAC3D,aAAa,EAAE,gBAAgB,EAAE,kBAAkB;IACnD,cAAc,EAAE,qBAAqB;AACzC;AACA,uBAAuB,cAAc,EAAE;AACvC,+BAA+B,0BAA0B,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;AACpG;IACI,cAAc,EAAE,eAAe;IAC/B,cAAc;IACd,iBAAiB;AACrB;AACA;;sCAEsC;AACtC,iBAAiB,cAAc,EAAE,mBAAmB,EAAE;AACtD,eAAe,cAAc,EAAE,gBAAgB,EAAE;AACjD,kBAAkB,SAAS,EAAE,kBAAkB,EAAE,cAAc,EAAE;AACjE,0EAA0E;AAC1E,iBAAiB,cAAc,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAEvE;6BAC6B;AAC7B,wBAAwB,iBAAiB,EAAE;AAC3C;sEACsE;AACtE;gBACgB;AAChB;mCACmC,6BAA6B,EAAE;AAClE,yCAAyC,cAAc,EAAE;AACzD,qBAAqB,cAAc,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AAC7E;IACI,SAAS,EAAE,cAAc,EAAE,gBAAgB;IAC3C,kBAAkB;IAClB;;;qCAGiC;IACjC,mBAAmB;AACvB;;AAEA;;yCAEyC;AACzC;;0CAE0C;AAC1C;IACI,cAAc;IACd,mBAAmB,EAAE,WAAW;IAChC,gBAAgB,EAAE,kBAAkB;IACpC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,iFAAiF;AACjF,iBAAiB,wCAAwC,EAAE;AAC3D,yDAAyD;AACzD;;2DAE2D;AAC3D,0BAA0B,sBAAsB,EAAE;AAClD;IACI,aAAa;IACb;;kEAE8D;IAC9D,qDAAqD;IACrD,SAAS;IACT,gBAAgB;AACpB;AACA,6BAA6B,gBAAgB,EAAE;AAC/C;IACI,mBAAmB,EAAE,gBAAgB,EAAE,YAAY;IACnD;+CAC2C;IAC3C,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;IAC3D,eAAe;AACnB;;AAEA,+EAA+E;AAC/E,cAAc,kBAAkB,EAAE;AAClC,oBAAoB,8BAA8B,EAAE,4BAA4B,EAAE;AAClF;IACI,kBAAkB,EAAE,WAAW,EAAE,QAAQ,EAAE,2BAA2B;IACtE,cAAc,EAAE,iBAAiB,EAAE,oBAAoB;AAC3D;;AAEA,yEAAyE;AACzE,qDAAqD,iBAAiB,EAAE,mBAAmB,EAAE,SAAS,EAAE;AACxG;IACI,WAAW,EAAE,YAAY,EAAE,sBAAsB;IACjD,eAAe,EAAE,yBAAyB,EAAE,kBAAkB;IAC9D,iBAAiB,EAAE,gBAAgB,EAAE,cAAc;AACvD;AACA,yCAAyC,mBAAmB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AACnG,qFAAqF;AACrF,0BAA0B,mBAAmB,EAAE,SAAS,EAAE;;AAE1D;2EAC2E;AAC3E,0BAA0B,kBAAkB,EAAE;;AAE9C,2BAA2B,mBAAmB,EAAE,SAAS,EAAE,iBAAiB,EAAE;AAC9E;iEACiE;AACjE,2CAA2C,oBAAoB,EAAE,sBAAsB,EAAE;AACzF,6DAA6D,gBAAgB,EAAE;;AAE/E,+DAA+D;AAC/D;IACI,WAAW,EAAE,sBAAsB;IACnC,gBAAgB;IAChB,yBAAyB,EAAE,kBAAkB;IAC7C,kBAAkB,EAAE,cAAc;AACtC;;AAEA;;wDAEwD;AACxD;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;AACA;2DAC2D;AAC3D,oCAAoC,mBAAmB,EAAE;AACzD,gDAAgD,0BAA0B,EAAE,kBAAkB,EAAE;AAChG,+CAA+C,0BAA0B,EAAE,mBAAmB,EAAE;AAChG,iDAAiD,gBAAgB,EAAE;;AAEnE;;8CAE8C;AAC9C;IACI,gBAAgB;IAChB,WAAW,EAAE,YAAY;IACzB,UAAU,EAAE,YAAY,EAAE,kBAAkB;IAC5C,mBAAmB,EAAE,WAAW;IAChC,iBAAiB,EAAE,cAAc;IACjC,eAAe,EAAE,sBAAsB;AAC3C;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,6BAA6B,0BAA0B,EAAE,mBAAmB,EAAE;;;AAG9E;8EAC8E;AAC9E;IACI,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB;IAC7E,yBAAyB,EAAE,cAAc,EAAE,iBAAiB;AAChE;;;AAGA;;4BAE4B;AAC5B;gCACgC,cAAc,EAAE;;AAEhD;8EAC8E;AAC9E,kBAAkB,gBAAgB,EAAE,kBAAkB,EAAE,cAAc,EAAE;;AAExE;;+BAE+B;AAC/B,gCAAgC,mBAAmB,EAAE;;AAErD,oBAAoB,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,SAAS,EAAE,cAAc,EAAE,2BAA2B,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;;AAExM,6EAA6E;AAC7E;IACI,oDAAoD;IACpD,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,kCAAkC;AACtC;AACA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,UAAU;AACd;;AAEA,uDAAuD;AACvD;IACI,kCAAkC;IAClC,yBAAyB;IACzB,UAAU;IACV,gBAAgB;AACpB","sourcesContent":["/* ==================== LAYOUT BASE (Estilo Obras) ==================== */\n.veiculos-container-new {\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n}\n\n/* Page Content - padding after top-bar */\n.veiculos-container-new>*:not(.top-bar) {\n    padding: 20px 30px;\n}\n\n/* ==================== VEHICLES SECTION ==================== */\n.vehicles-section {\n    background: transparent;\n    padding: 0;\n    margin-bottom: 35px;\n}\n\n.vehicles-section h3 {\n    margin: 0 0 15px 0;\n    font-size: 0.9rem;\n    color: #718096;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.vehicles-grid-compact {\n    display: grid;\n    /* Toda a frota numa linha: as colunas dividem a largura em partes iguais,\n       seja qual for o número de viaturas. Abaixo dos 140px por cartão a linha\n       passa a deslizar na horizontal em vez de os espremer até não se lerem.\n\n       Colunas todas iguais é o que se quer, e não uma limitação a contornar:\n       já se experimentou dar mais largura só ao cartão das alugadas e o que\n       saiu foi um cartão destoante ao lado dos outros. */\n    /* As colunas são tantas quantos os cartões (o número vem do próprio ecrã,\n       em --n-cartoes) e dividem a largura disponível em partes iguais. Assim a\n       fila acaba exatamente onde acaba o painel de baixo, seja qual for o\n       tamanho do ecrã — e não a meio, como acontecia com a largura fixa.\n\n       O mínimo de 5,1 cm é o que impede que os cartões se espremam: abaixo\n       disso a fila deixa de caber e passa a deslizar na horizontal, que é o que\n       o overflow aqui em baixo já previa. Num ecrã largo o minmax cresce até\n       preencher; o problema antigo do minmax era com grid-auto-columns, onde a\n       coluna partia do mínimo e não esticava. Com grid-template-columns e uma\n       contagem conhecida, estica. */\n    grid-template-columns: repeat(var(--n-cartoes, 8), minmax(5.1cm, 1fr));\n    justify-content: stretch;\n    /* Em milímetros porque foi assim que o afastamento foi pedido, e porque a\n       largura da coluna aqui em cima também é métrica. Eram 10px — 2,65 mm — e\n       a fila ficou deliberadamente muito mais apertada do que isso: os cartões\n       quase a tocar-se, com o vinco entre eles a chegar para os separar. É\n       este o valor a mexer se um dia voltar a parecer apertado ou largo. */\n    gap: 2.9mm;\n    overflow-x: auto;\n    padding-bottom: 4px;\n}\n\n.vehicle-card-compact {\n    background: white;\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n    transition: all 0.2s;\n    border: 1px solid transparent;\n}\n\n.vehicle-card-compact:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);\n    border-color: #4299e1;\n}\n\n.card-header-compact {\n    display: flex;\n    justify-content: space-between;\n    align-items: start;\n    margin-bottom: 12px;\n}\n\n.card-header-compact strong {\n    font-size: 1.1rem;\n    color: #2d3748;\n    font-weight: 700;\n    display: block;\n}\n\n.matricula-small {\n    display: inline-block;\n    background: #edf2f7;\n    color: #667eea;\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-size: 0.75rem;\n    margin-top: 6px;\n    font-weight: 600;\n}\n\n.card-actions-compact {\n    display: flex;\n    gap: 8px;\n}\n\n.btn-icon-small {\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f1f5f9;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-icon-small:hover {\n    background: #ebf8ff;\n    border-color: #3182ce;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 6px rgba(49, 130, 206, 0.1);\n}\n\n.btn-icon-small.delete:hover {\n    background: #fee2e2;\n    border-color: #f56565;\n}\n\n.card-info-compact {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding-top: 12px;\n    border-top: 1px solid #edf2f7;\n}\n\n.status-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    display: inline-block;\n}\n\n.status-dot.status-valid {\n    background: #48bb78;\n}\n\n.status-dot.status-warning {\n    background: #ed8936;\n}\n\n.status-dot.status-expired {\n    background: #f56565;\n}\n\n.card-info-compact span:not(.status-dot) {\n    font-size: 0.85rem;\n    color: #718096;\n}\n\n/* ==================== TRIPS SECTION ==================== */\n.trips-section {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n    overflow: hidden;\n    border: 1px solid #e2e8f0;\n}\n\n.trips-header {\n    background: white;\n    border-bottom: 2px solid #e2e8f0;\n    padding: 20px 24px;\n}\n\n.trips-header h3 {\n    margin: 0;\n    font-size: 1.2rem;\n    color: #2d3748;\n    font-weight: 700;\n}\n\n/* Inline Trip Form */\n.trip-form-card {\n    background: #f8fafc;\n    padding: 20px 24px;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n/* Capture View Container */\n.capture-view {\n    max-width: 600px;\n    margin: 0 auto;\n    width: 100%;\n}\n\n.capture-card {\n    background: white;\n    border-radius: 20px;\n    padding: 25px;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n    margin-bottom: 20px;\n    border: none;\n}\n\n/* Mobile Form Styles */\n.mobile-form-group {\n    margin-bottom: 20px;\n}\n\n.mobile-form-group label {\n    display: block;\n    font-size: 0.85rem;\n    color: #a0aec0;\n    margin-bottom: 8px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.mobile-form-input,\n.mobile-form-select {\n    width: 100%;\n    padding: 16px;\n    font-size: 1.1rem;\n    border: 2px solid #edf2f7;\n    border-radius: 12px;\n    background: #f7fafc;\n    color: #2d3748;\n    transition: all 0.2s;\n    -webkit-appearance: none;\n    appearance: none;\n}\n\n.mobile-form-input:focus,\n.mobile-form-select:focus {\n    outline: none;\n    border-color: #4299e1;\n    background: white;\n    box-shadow: 0 0 0 4px rgba(66, 153, 225, 0.1);\n}\n\n.btn-large-submit {\n    width: 100%;\n    padding: 18px;\n    background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%);\n    color: white;\n    border: none;\n    border-radius: 16px;\n    font-size: 1.1rem;\n    font-weight: 700;\n    cursor: pointer;\n    box-shadow: 0 8px 15px rgba(49, 130, 206, 0.2);\n    transition: transform 0.1s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 10px;\n}\n\n.btn-large-submit:active {\n    transform: scale(0.96);\n}\n\n/* Mobile Recent List */\n.mobile-recent-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.mobile-recent-item {\n    background: white;\n    border-radius: 16px;\n    padding: 15px;\n    margin-bottom: 10px;\n    border: 1px solid #edf2f7;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.02);\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.mobile-recent-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n}\n\n.mobile-recent-info h4 {\n    margin: 0;\n    font-size: 0.95rem;\n    color: #2d3748;\n    font-weight: 700;\n}\n\n.mobile-recent-meta {\n    font-size: 0.8rem;\n    color: #718096;\n    margin-top: 2px;\n}\n\n.mobile-recent-value {\n    font-weight: 700;\n    color: #3182ce;\n    font-size: 1rem;\n    background: #ebf8ff;\n    padding: 4px 10px;\n    border-radius: 8px;\n}\n\n.mobile-recent-actions {\n    display: flex;\n    gap: 8px;\n    border-top: 1px solid #f7fafc;\n    padding-top: 10px;\n}\n\n.btn-mobile-action {\n    flex: 1;\n    padding: 8px;\n    border-radius: 8px;\n    border: none;\n    font-weight: 600;\n    font-size: 0.9rem;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n}\n\n.btn-mobile-action.delete {\n    background: #fff5f5;\n    color: #e53e3e;\n    border: 1px solid #fed7d7;\n}\n\n.trip-form-inline {\n    display: grid;\n    grid-template-columns: 140px 200px 160px 100px 130px 1fr auto;\n    gap: 15px;\n    align-items: end;\n}\n\n.form-group-inline {\n    display: flex;\n    flex-direction: column;\n}\n\n.form-group-inline.small {\n    max-width: 120px;\n}\n\n.form-group-inline label {\n    font-size: 0.75rem;\n    font-weight: 700;\n    color: #4a5568;\n    margin-bottom: 6px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.form-group-inline input,\n.form-group-inline select {\n    padding: 10px 12px;\n    border: 1px solid #cbd5e0;\n    border-radius: 8px;\n    font-size: 0.9rem;\n    transition: all 0.2s;\n    background: white;\n}\n\n.form-group-inline input:focus,\n.form-group-inline select:focus {\n    outline: none;\n    border-color: #4299e1;\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n.btn-add-trip {\n    padding: 10px 20px;\n    background: #4299e1;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-size: 0.9rem;\n}\n\n.btn-add-trip:hover {\n    background: #3182ce;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(66, 153, 225, 0.3);\n}\n\n/* Filters Bar */\n.filters-bar {\n    display: flex;\n    gap: 20px;\n    padding: 20px 24px;\n    background: white;\n    border-bottom: 2px solid #e2e8f0;\n    align-items: end;\n}\n\n.filter-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.filter-group label {\n    font-size: 0.75rem;\n    font-weight: 700;\n    color: #4a5568;\n    margin-bottom: 6px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.filter-group select {\n    padding: 8px 12px;\n    border: 1px solid #cbd5e0;\n    border-radius: 8px;\n    min-width: 160px;\n    background: white;\n    font-size: 0.9rem;\n    transition: all 0.2s;\n}\n\n.filter-group select:focus {\n    outline: none;\n    border-color: #4299e1;\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n.totals-display {\n    margin-left: auto;\n    display: flex;\n    gap: 25px;\n    padding: 10px 20px;\n    background: #f8fafc;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n}\n\n.totals-display span {\n    font-size: 0.9rem;\n    color: #2d3748;\n    font-weight: 500;\n}\n\n.totals-display strong {\n    color: #4299e1;\n    font-weight: 700;\n    margin-right: 6px;\n}\n\n/* Trips Table */\n.trips-table-container {\n    overflow-x: auto;\n    max-height: 500px;\n    overflow-y: auto;\n}\n\n.trips-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.trips-table thead {\n    position: sticky;\n    top: 0;\n    background: #f8fafc;\n    z-index: 10;\n}\n\n.trips-table th {\n    padding: 14px 16px;\n    text-align: left;\n    font-size: 0.75rem;\n    font-weight: 700;\n    color: #4a5568;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    border-bottom: 2px solid #e2e8f0;\n}\n\n.trips-table td {\n    padding: 16px;\n    border-bottom: 1px solid #edf2f7;\n    font-size: 0.9rem;\n    color: #2d3748;\n}\n\n.trips-table tbody tr {\n    transition: background 0.2s;\n}\n\n.trips-table tbody tr:hover {\n    background: #f8fafc;\n}\n\n.matricula-tag {\n    display: inline-block;\n    background: #edf2f7;\n    color: #667eea;\n    padding: 3px 10px;\n    border-radius: 12px;\n    font-size: 0.75rem;\n    margin-left: 8px;\n    font-weight: 600;\n}\n\n.empresa-tag {\n    display: inline-block;\n    background: #4299e1;\n    color: white;\n    padding: 5px 14px;\n    border-radius: 16px;\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n\n.btn-icon-delete {\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f1f5f9;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 1rem;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.btn-icon-delete:hover {\n    background: #fee2e2;\n    border-color: #f56565;\n    transform: translateY(-2px);\n}\n\n/* ==================== MODALS ==================== */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1100;\n}\n\n.modal-content {\n    background: white;\n    padding: 0;\n    border-radius: 12px;\n    max-width: 600px;\n    width: 90%;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 24px;\n    border-bottom: 2px solid #e2e8f0;\n    background: white;\n}\n\n.modal-header h2 {\n    margin: 0;\n    font-size: 1.4rem;\n    color: #2d3748;\n    font-weight: 700;\n}\n\n.close-btn {\n    background: #f1f5f9;\n    border: none;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    font-size: 1.5rem;\n    cursor: pointer;\n    color: #4a5568;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}\n\n.close-btn:hover {\n    background: #e2e8f0;\n    color: #2d3748;\n}\n\n.modal-content form {\n    padding: 24px;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 700;\n    color: #2d3748;\n    font-size: 0.9rem;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid #cbd5e0;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    transition: all 0.2s;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n    outline: none;\n    border-color: #4299e1;\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n.modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 24px;\n    padding-top: 20px;\n    border-top: 1px solid #e2e8f0;\n}\n\n/* ==================== BUTTONS ==================== */\n.btn-primary,\n.btn-secondary {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-size: 0.9rem;\n}\n\n.btn-primary {\n    background: #4299e1;\n    color: white;\n}\n\n.btn-primary:hover {\n    background: #3182ce;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(66, 153, 225, 0.3);\n}\n\n.btn-secondary {\n    background: #e2e8f0;\n    color: #2d3748;\n}\n\n.btn-secondary:hover {\n    background: #cbd5e0;\n}\n\n/* ==================== RESPONSIVE ==================== */\n@media (max-width: 1024px) {\n    .trip-form-inline {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .btn-add-trip {\n        grid-column: 1 / -1;\n    }\n\n    .vehicles-grid-compact { grid-template-columns: repeat(var(--n-cartoes, 8), minmax(5.1cm, 1fr)); }\n}\n\n@media (max-width: 768px) {\n    .mobile-hide {\n        display: none !important;\n    }\n\n    .veiculos-container-new>*:not(.top-bar) {\n        padding: 0 15px 15px 15px;\n        /* No top padding */\n    }\n\n    .top-bar {\n        padding: 10px 15px;\n    }\n\n    .top-bar h1 {\n        font-size: 1.1rem;\n    }\n\n    .vehicles-grid-compact { grid-template-columns: repeat(var(--n-cartoes, 8), minmax(150px, 1fr)); }\n\n    .trip-form-inline {\n        grid-template-columns: 1fr;\n    }\n\n    .filters-bar {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .filter-group select {\n        width: 100%;\n    }\n\n    .totals-display {\n        margin-left: 0;\n        flex-direction: column;\n        gap: 10px;\n    }\n}\n/* ============================================================\n   CARTÃO DE VIATURA — a fotografia primeiro\n\n   Antes era uma linha de texto com o nome e a matrícula lado a lado. Numa\n   frota pequena reconhece-se a carrinha pela imagem muito antes de se ler a\n   matrícula, por isso a fotografia passou a mandar no cartão, com a marca e\n   modelo por baixo e a matrícula a seguir, tratada como chapa.\n   ============================================================ */\n.vehicle-card {\n    position: relative;\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    overflow: hidden;\n    cursor: pointer;                 /* o cartão inteiro abre a edição */\n    transition: box-shadow .15s, border-color .15s;\n}\n.vehicle-card:hover { border-color: #cbd5e1; box-shadow: 0 3px 10px rgba(15, 23, 42, .08); }\n.vehicle-card:focus-visible { outline: 2px solid #3182ce; outline-offset: 2px; }\n\n.vehicle-foto {\n    position: relative;\n    /* Um pouco mais alta do que a média das proporções da frota (1.65), para\n       o nome e a chapa assentarem mais abaixo no cartão. As viaturas aparecem\n       inteiras à mesma — a fotografia encaixa dentro da moldura, não é\n       cortada.\n\n       O min-height e o overflow não são enfeite: sem eles a proporção cede\n       perante o conteúdo, e uma fotografia mais alta do que 1.65 estica a caixa\n       em vez de ser ela a encolher. Era isso que punha os cartões do Cabstar,\n       do Movano e de uma das Ducato mais altos do que os restantes. */\n    aspect-ratio: 1.5;\n    min-height: 0;\n    overflow: hidden;\n    background: #f1f5f9;\n    display: grid;\n    place-items: center;\n    color: #94a3b8;                 /* dá a cor ao desenho por omissão */\n    border-bottom: 1px solid #e2e8f0;\n}\n/* contain e não cover: as viaturas têm feitios muito diferentes e o cover\n   cortava-lhes as pontas para encher o quadro. */\n.vehicle-foto img { width: 100%; height: 100%; object-fit: contain; display: block; }\n\n/* A fotografia gere-se na janela de edição, não por cima do cartão. A imagem\n   em si mostra-se no cabeçalho; aqui ficam só os botões que agem sobre ela. */\n.modal-foto-btns { display: flex; gap: 8px; align-items: flex-start; }\n.btn-foto-modal { cursor: pointer; margin: 0; }\n\n.vehicle-corpo { padding: 8px 7px 9px; text-align: center; }\n.vehicle-nome {\n    /* Altura de duas linhas mesmo quando só ocupa uma: um nome que parta ao\n       meio deslocava a chapa e tudo o que vem por baixo só nesse cartão. */\n    display: flex; align-items: center; justify-content: center;\n    min-height: 2.4em;\n    font-size: 0.8rem; font-weight: 700; color: #1e293b;\n    line-height: 1.2; margin-bottom: 6px;\n}\n\n/* Chapa de matrícula a sério, em vez de uma etiqueta com ar de chapa. */\n.chapa {\n    display: inline-flex; align-items: stretch; overflow: hidden;\n    /* Medidas tiradas da chapa real: largura ~4,6x a altura, caracteres a\n       ocupar ~70% da altura, banda da UE ~9% da largura e moldura preta. */\n    height: 21px; border-radius: 3px;\n    border: 1px solid #1c1c1c;\n    background: linear-gradient(#fdfdfc, #efefec);\n    box-shadow: 0 1px 2px rgba(15, 23, 42, .22);\n}\n/* O azul vem do CSS e não só do <rect>: o viewBox (22x48) não tem a mesma\n   proporção da caixa, por isso o browser encaixa o desenho e deixa uma calha\n   de cada lado. Com o fundo aqui, a calha também fica azul. */\n.chapa-ue { display: block; width: 9px; height: 100%; flex: none; background: #003399; }\n.chapa-num {\n    display: flex; align-items: center; padding: 0 4px 0 3px;\n    /* Na chapa portuguesa os algarismos são ovais altos e estreitos: a largura\n       de cada um dá pouco menos de metade da altura das maiúsculas. Daí uma\n       condensada — uma fonte larga faria a chapa crescer para o dobro. */\n    font-family: \"Arial Narrow\", \"Helvetica Neue Condensed\", \"Roboto Condensed\", Arial, sans-serif;\n    font-stretch: condensed;\n    font-size: 1.15rem; font-weight: 700; letter-spacing: .06em;\n    line-height: 1; color: #1a1a1a; white-space: nowrap;\n}\n/* Entre grupos vai um quadrado, não um ponto redondo. Sem margem à esquerda:\n   o letter-spacing do último caractere do grupo já abre esse espaço. */\n.chapa-sep {\n    flex: none; align-self: center;\n    width: 2px; height: 2px; border-radius: .5px;\n    background: currentColor;\n    margin: 0 2px 0 0;\n}\n.vehicle-acoes {\n    position: absolute; bottom: 8px; right: 8px; display: flex; gap: 3px;\n    opacity: 0; transition: opacity .15s;\n}\n.vehicle-card:hover .vehicle-acoes,\n.vehicle-acoes:focus-within { opacity: 1; }\n\n/* ============================================================\n   CABEÇALHO DA JANELA DE EDIÇÃO\n\n   Em vez do título \"Editar Veículo\", a própria viatura: fotografia, marca e\n   modelo, e a chapa. Quem abre a janela vê logo em qual está a mexer, sem ter\n   de ler a matrícula num campo de texto.\n   ============================================================ */\n.modal-header-viatura {\n    align-items: flex-start;\n    /* 10px em cima para a carrinha não encostar ao topo. Em baixo só o\n       necessário para a chapa não colar à linha divisória — e é aí que os\n       campos ganham altura, porque sobem com ela. */\n    padding: 10px 24px 20px;\n}\n/* O formulário encostava-se à chapa com 24px por cima, o que abria um vão\n   grande entre a matrícula e o primeiro campo. */\n/* A linha divisória desceu 6px (padding do cabeçalho), mas os campos ficam onde\n   estavam: esta margem negativa devolve-lhes exatamente esses 6px. Sem ela, os\n   campos desciam atrás da linha. */\n.modal-content .modal-header-viatura + form { padding-top: 0; margin-top: -6px; }\n\n/* Os campos desta janela são poucos e curtos: os 20px de intervalo herdados\n   deixavam-nos a boiar. Presos à classe da janela para não mexer nas outras. */\n.modal-content-viatura .form-group { margin-bottom: 8px; }\n/* Quem separa as duas linhas de campos é este valor. */\n.modal-content-viatura .linha-seguro .form-group { margin-bottom: 12px; }\n.modal-content-viatura .linha-seguro { margin-bottom: 0; }\n.modal-viatura {\n    flex: 1;\n    display: flex; flex-direction: column; align-items: center;\n    text-align: center;\n    gap: 3px;\n}\n.modal-viatura-foto {\n    /* Mesma proporção do cartão, pela mesma razão: a frota tem feitios\n       diferentes e o quadro tem de servir a todos. */\n    width: 250px; max-width: 100%; aspect-ratio: 1.65;\n    display: grid; place-items: center; overflow: hidden;\n    /* Sem fundo nem moldura: a fotografia é um PNG recortado, e assim a\n       viatura assenta na janela em vez de ficar dentro de uma caixa. */\n    background: transparent; color: #94a3b8;\n}\n/* contain e não cover: sem fundo por trás, um recorte cortado nas pontas ficava\n   a flutuar mal. Assim a viatura aparece inteira. */\n.modal-viatura-foto img { width: 100%; height: 100%; object-fit: contain; display: block; }\n.modal-viatura-nome {\n    font-size: 1.05rem; font-weight: 700; color: #1e293b; line-height: 1.25;\n}\n\n.modal-foto-btns-linha { flex-wrap: wrap; }\n\n/* Companhia, apólice e validade do seguro lado a lado. A companhia leva 1.4\n   porque \"Generali Tranquilidade\" é bem mais comprido do que um número de\n   apólice ou uma data; abaixo dos 520px o telemóvel empilha-os. */\n/* Esta janela é mais larga do que as outras: são três campos na mesma linha e\n   a companhia de seguros precisa de espaço.\n\n   O seletor leva o .modal-overlay à frente por necessidade, não por gosto: o\n   Utilizadores.css também declara .modal-content, com max-width 500px, e o CSS\n   aqui é global. Com a mesma especificidade ganhava a regra que viesse depois\n   no pacote — e vinha a dos Utilizadores, que prendia esta janela nos 500px. */\n.modal-overlay .modal-content-viatura {\n    max-width: 480px;\n    /* O padding também tem de vir daqui: o Utilizadores.css declara\n       .modal-content com padding 30px e ganhava ao padding 0 deste ficheiro,\n       o que punha 30px de vazio por cima da carrinha. */\n    padding: 0;\n}\n\n.linha-seguro {\n    display: grid;\n    /* Larguras fixas e medidas, não proporções. Os 165px da seguradora são uma\n       escolha do Tiago, abaixo dos 177px que \"Generali Tranquilidade\" pede por\n       campo. 136px é o mínimo de um campo de data: dd/mm/aaaa ocupa 88px (mais\n       do que uma data preenchida, por causa das letras), o ícone do calendário\n       17px, e as margens internas 26px. A seguradora leva a mesma medida. */\n    grid-template-columns: 136px 132px 136px;\n    justify-content: center;\n    gap: 14px;\n    /* As caixas alinham-se pela base. Sem isto, um título que se parta em duas\n       linhas — \"Companhia Seguros\" numa coluna estreita — empurrava a sua caixa\n       para baixo e desalinhava a linha toda. */\n    align-items: end;\n}\n/* A MESMA grelha da linha de cima, e não uma grelha de duas colunas: só assim\n   as caixas caem debaixo da Seguradora e da Apólice. Uma grelha própria, ainda\n   que centrada, começaria noutro sítio. A terceira coluna fica vazia. */\n.linha-inspecao {\n    display: grid;\n    grid-template-columns: 136px 132px 136px;\n    justify-content: center;\n    gap: 14px;\n}\n@media (max-width: 620px) {\n    .linha-seguro, .linha-inspecao { grid-template-columns: 136px; }\n}\n\n/* Títulos e valores ao centro, cada título por cima do seu campo.\n\n   Preso a .modal-content-viatura e não a .modal-content: o CSS aqui é global e\n   .modal-content também é usado nas janelas dos Utilizadores e do Detalhe de\n   Obra, que não têm nada que ver com isto. */\n.modal-content-viatura .form-group label {\n    text-align: center;\n    margin-bottom: 0;\n    /* O intervalo por omissão da linha deixa uma folga por cima do texto que\n       aqui não serve para nada e afastava a segunda linha da primeira. */\n    line-height: 1.15;\n}\n.modal-content-viatura .form-group input,\n.modal-content-viatura .form-group select {\n    text-align: center;\n    /* Altura fixa e igual para todos. O navegador desenha um campo de data com\n       altura ligeiramente diferente de um campo de texto, e como as caixas se\n       alinham pela base, essa diferença aparecia em cima: o título \"Validade\n       Seguro\" ficava mais alto do que os outros dois. */\n    box-sizing: border-box;\n    height: 42px;\n}\n/* A data fica à esquerda. Centrá-la obrigava a compensar o ícone do calendário\n   com margem do lado esquerdo, e essa margem roubava a largura de que a própria\n   data precisava — 20/01/2026 aparecia cortado. */\n.modal-content-viatura .form-group input[type=\"date\"] {\n    text-align: left;\n    padding-left: 12px;\n}\n\n/* ============================================================\n   LEITURAS DO CONTA-QUILÓMETROS\n   ============================================================ */\n/* Cada viatura é o cartão mais o botão, empilhados. O botão fica fora do\n   cartão de propósito: assim não tem de travar o clique que abre a edição. */\n.vehicle-item {\n    display: flex; flex-direction: column;\n    /* Sem isto, as colunas não ficam todas do mesmo tamanho: os botões e as\n       etiquetas têm white-space: nowrap, e um item de grelha recusa-se a\n       encolher abaixo do seu conteúdo mínimo. A coluna crescia, e como a altura\n       da fotografia sai da largura, esse cartão ficava mais alto do que os\n       outros. */\n    min-width: 0;\n}\n\n.btn-kms {\n    width: 100%; margin-top: 6px;\n    padding: 7px 4px;\n    border: 1px solid #cbd5e0; border-radius: 7px;\n    background: #e2e8f0; color: #334155;\n    font-size: 0.84rem; font-weight: 600; cursor: pointer;\n    white-space: nowrap;\n    transition: background .15s, border-color .15s;\n}\n.btn-kms:hover { background: #cbd5e1; border-color: #94a3b8; }\n.btn-kms:focus-visible { outline: 2px solid #3182ce; outline-offset: 1px; }\n\n/* Fica por cima da janela da viatura, que continua aberta por baixo. */\n.modal-kms-overlay { z-index: 3000; }\n.modal-overlay .modal-kms {\n    /* Mais larga do que as outras: leva tabelas com descrições de eventos, que\n       são texto livre e não cabem numa coluna estreita. */\n    max-width: 720px;\n    padding: 0;\n}\n.modal-kms .kms-form { padding: 4px 24px 14px; }\n.kms-form {\n    display: grid;\n    /* Larguras à medida e o conjunto ao centro, em vez de a segunda coluna\n       esticar até ao fim da janela. */\n    grid-template-columns: 150px 150px auto;\n    justify-content: center;\n    gap: 12px;\n    align-items: end;\n    padding: 8px 24px 14px;\n}\n.kms-form .form-group { margin-bottom: 0; }\n/* Título por cima do seu campo, e o valor ao centro da caixa. */\n.modal-kms .form-group label { text-align: center; margin-bottom: 4px; }\n.modal-kms .form-group input { text-align: center; box-sizing: border-box; height: 42px; }\n/* A data leva o ícone do calendário à direita: centrá-la roubava-lhe a largura\n   de que precisa, e dd/mm/aaaa aparecia cortado. */\n.modal-kms .form-group input[type=\"date\"] { text-align: left; }\n.kms-registar { height: 42px; white-space: nowrap; }\n\n.kms-erro, .kms-aviso {\n    margin: 0 24px 12px; padding: 9px 12px;\n    border-radius: 8px; font-size: 0.85rem;\n}\n.kms-erro { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }\n.kms-aviso { background: #fffbeb; color: #92400e; border: 1px solid #fde68a; }\n\n.kms-historico { padding: 0 24px 20px; max-height: 320px; overflow-y: auto; }\n.kms-vazio { margin: 6px 0 0; color: #64748b; font-size: 0.86rem; }\n/* separate e não collapse: com as bordas colapsadas o navegador ignora o\n   border-radius das células, e o retângulo do total ficava de pontas vivas. O\n   espaçamento a zero mantém o aspeto de tabela colapsada. */\n.kms-tabela { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 0.86rem; }\n.kms-tabela th {\n    text-align: center; padding: 6px 8px;\n    color: #64748b; font-weight: 600; font-size: 0.76rem;\n    border-bottom: 1px solid #e2e8f0;\n    position: sticky; top: 0; background: #fff;\n}\n/* Valores ao centro, como os títulos. As exceções são a ocorrência, que é texto\n   corrido e se lê melhor encostada à esquerda, e o montante, que tem de alinhar\n   pela vírgula. */\n.kms-tabela td { padding: 7px 8px; border-bottom: 1px solid #f1f5f9; color: #1e293b; text-align: center; }\n.kms-tabela td.col-texto { text-align: left; }\n.kms-tabela tr:last-child td { border-bottom: none; }\n/* Um conta-quilómetros não anda para trás: se aparecer, é engano a assinalar. */\n.kms-negativo { color: #b91c1c; font-weight: 700; }\n\n/* Resumo do período, por cima da lista. */\n.kms-resumo {\n    display: grid;\n    /* Os quatro na mesma linha; em ecrã estreito partem para duas. */\n    grid-template-columns: repeat(4, 1fr);\n    gap: 10px 16px;\n    margin: 0 24px 14px;\n    padding: 12px 14px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    text-align: center;\n}\n.kms-resumo div {\n    display: flex; flex-direction: column; align-items: center; gap: 2px;\n}\n.kms-resumo span {\n    font-size: 0.72rem; color: #64748b; line-height: 1.25;\n    /* Altura de duas linhas mesmo nos títulos de uma só: sem isto, o valor de\n       \"Percorridos no período\" ficava uma linha abaixo dos restantes. */\n    min-height: 2.1em;\n}\n.kms-resumo strong { font-size: 0.86rem; color: #1e293b; }\n@media (max-width: 620px) {\n    .kms-resumo { grid-template-columns: repeat(2, 1fr); }\n}\n\n/* Título ao centro da janela, e não do espaço que sobra ao lado do X. Com o\n   botão de fechar tirado do fluxo, o título centra-se na largura toda; a\n   margem lateral impede que um nome comprido lhe passe por baixo. */\n/* 4px por cima do título e 4px por baixo dele: a linha divisória continua com o\n   mesmo ar dos dois lados, e todo o bloco sobe. */\n.modal-kms .modal-header { position: relative; justify-content: center; padding: 4px 24px; }\n.modal-kms .modal-header h2 { margin: 0; text-align: center; padding: 0 40px; }\n.modal-kms .modal-header .close-btn {\n    position: absolute; right: 24px; top: 50%;\n    transform: translateY(-50%);\n}\n\n/* Botões do rodapé com a mesma largura e ao centro. Os 180px vêm do rótulo\n   mais comprido — \"Guardar Alterações\" pede 179px com as margens internas —\n   para que \"Cancelar\" fique do mesmo tamanho sem apertar o outro. */\n.modal-content-viatura .modal-footer {\n    justify-content: center;\n    gap: 10px;\n}\n.modal-content-viatura .modal-footer button {\n    min-width: 180px;\n    height: 42px;\n    box-sizing: border-box;\n    /* Centragem declarada e não herdada: com altura fixa e o padding assimétrico\n       que estes botões trazem, o texto não assentava ao meio sozinho. */\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 0 16px;\n}\n\n/* Campo que mostra um valor calculado noutro sítio: sem moldura de campo\n   editável, para não convidar a escrever nele. */\n.modal-content-viatura .campo-so-leitura {\n    background: #f8fafc;\n    color: #475569;\n    cursor: default;\n}\n\n/* Resumo por baixo dos botões. Duas colunas por linha — etiqueta à esquerda,\n   valor à direita — para se ler em varrimento vertical. */\n.vehicle-resumo {\n    /* De volta ao fundo do cartão. Só é possível ter ao mesmo tempo os títulos\n       alinhados e os cartões a fechar rentes porque o bloco tem agora sempre a\n       mesma altura: as linhas do \"ou\" e da data existem em todos, invisíveis\n       quando não há data. */\n    margin: auto 0 0;\n    padding: 7px 7px;\n    background: #fff;\n    border: 1px solid #e2e8f0;\n    border-radius: 7px;\n    font-size: 0.74rem;\n\n    /* UMA grelha para as três linhas, e não uma grelha por linha: só assim as\n       etiquetas e os valores partilham as mesmas colunas. Com uma grelha por\n       linha, a coluna da etiqueta ajustava-se ao comprimento da sua palavra e\n       \"Inspeção:\" empurrava o seu valor mais para a direita do que \"Seguro:\". */\n    display: grid;\n    /* Colunas do tamanho do que levam dentro, e o par encostado à esquerda. O\n       \"1fr\" na segunda coluna está fora de questão: ela comia toda a largura\n       que sobrava e o bloco ia esparramar-se até à direita. O que sobra fica\n       todo do lado direito, de propósito — as etiquetas é que mandam no eixo. */\n    grid-template-columns: auto auto;\n    justify-content: start;\n    gap: 0 5px;\n    align-items: baseline;\n}\n/* O cartão das alugadas não tem os três botões por cima do resumo, e por isso\n   o retângulo faz sozinho o caminho que nos outros é dos botões e do resumo:\n   começa aos mesmos 6px do .btn-kms, à altura do \"Registar kms\" dos vizinhos,\n   e cresce até fechar rente ao resumo deles em baixo.\n\n   O crescer é do flex-grow, não de uma altura escrita à mão — assim acompanha\n   os vizinhos se um dia lá aparecer mais uma linha ou outro botão. E é o\n   flex-grow e não o \"flex: 1\": com a base a zero o retângulo podia encolher\n   abaixo do que leva dentro e deixar o texto a sair fora.\n\n   Dentro é uma lista de viaturas e não os pares etiqueta/valor da grelha de\n   cima: o mês à cabeça e, por baixo, cada alugada com a chapa e o consumo a\n   que andou. Tudo encostado ao topo, logo a seguir ao filtro — ao centro, as\n   viaturas descolavam-se dele e ficavam a boiar no meio do retângulo.\n\n   O min-height com o overflow é para o dia em que houver alugadas a mais para\n   a altura disponível: sem eles, era este cartão a esticar e a puxar a fila\n   toda atrás dele, que é precisamente o que a altura igual evita. */\n.vehicle-resumo.resumo-alugadas {\n    margin: 6px 0 0;\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    /* Tem de estar escrito: a regra de cima alinha pela baseline, o que serve\n       os pares etiqueta/valor mas aqui deixava cada linha com a largura do que\n       tem dentro em vez da largura do cartão. Era o que fazia os doze meses\n       acabarem a meio, com o resto do retângulo em branco à direita. */\n    align-items: stretch;\n    gap: 10px;\n    min-height: 0;\n    overflow-y: auto;\n}\n\n/* O ano numa caixa e os doze meses numa grelha por baixo. Os meses são botões\n   soltos e não um <select multiple>: escolher meses separados num select\n   obriga a arrastar com a tecla de controlo carregada, e num espaço destes o\n   painel nem se lê. Assim vê-se de relance o que está escolhido. */\n.alugadas-filtro { display: flex; flex-direction: column; gap: 5px; margin-bottom: 2px; }\n.alugadas-filtro select {\n    width: 100%; min-width: 0;\n    padding: 2px 3px;\n    /* O text-align-last vai junto: há browsers que ignoram o text-align na\n       linha escolhida de um <select> e deixavam o ano encostado à esquerda. */\n    text-align: center; text-align-last: center;\n    font-size: 0.68rem; font-family: inherit; color: #334155;\n    background: #f8fafc;\n    border: 1px solid #cbd5e0; border-radius: 5px;\n    cursor: pointer;\n}\n.alugadas-filtro select:focus-visible { outline: 2px solid #3182ce; outline-offset: 1px; }\n\n/* Os doze numa só linha, por número, a repartir a largura toda do cartão em\n   partes iguais. Cada casa fica com uns 14px, o que só dá para dois algarismos\n   apertados — daí o gap de 1px, o padding lateral a zero e a letra mais\n   pequena do que a do resto do cartão. Quem precisar do nome do mês tem-no no\n   title.\n\n   O minmax(0, 1fr) e não 1fr à seca: um \"1fr\" não deixa a casa encolher abaixo\n   do que leva dentro, e as três de dois algarismos ficavam mais largas do que\n   as outras nove. Com o mínimo a zero, as doze medem todas o mesmo. */\n.alugadas-meses { display: grid; grid-template-columns: repeat(12, minmax(0, 1fr)); gap: 1px; }\n.alugadas-mes {\n    padding: 2px 0;\n    font-size: 0.58rem; font-weight: 600; font-family: inherit;\n    color: #475569; background: #f8fafc;\n    border: 1px solid #cbd5e0; border-radius: 3px;\n    cursor: pointer;\n    transition: background .12s, border-color .12s, color .12s;\n}\n.alugadas-mes:hover { background: #e2e8f0; border-color: #94a3b8; }\n.alugadas-mes.on { background: #1e40af; border-color: #1e40af; color: #fff; }\n.alugadas-mes.on:hover { background: #1d4ed8; }\n.alugadas-mes:focus-visible { outline: 2px solid #3182ce; outline-offset: 1px; }\n/* Desfaz o \"display: contents\" da regra aqui em baixo, que dissolvia estas\n   linhas na grelha do pai — grelha que este retângulo já não usa. */\n.vehicle-resumo.resumo-alugadas > div { display: block; }\n\n/* O que desliza é a lista, não o retângulo todo: o ano e os meses ficam à\n   vista sempre, senão quem desce para ver a quarta viatura perde de vista o\n   período a que os números dizem respeito.\n\n   250px dão quase quatro linhas — a partir daí desliza. É o espaço que o\n   retângulo tem hoje por baixo do filtro; passar disso empurrava o cartão\n   para baixo dos outros. */\n.alugadas-lista {\n    max-height: 250px;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    min-height: 0;\n}\n\n.alugada-linha { text-align: center; }\n.alugada-linha + .alugada-linha { border-top: 1px solid #f1f5f9; padding-top: 10px; }\n/* A matrícula em texto, a fazer de título da linha. Sem moldura nem fundo: é\n   um botão pelo que faz, não pelo que parece. */\n.alugada-chapa {\n    display: block; margin: 0 auto;\n    border: none; background: none; padding: 0; cursor: pointer;\n    font: inherit; font-weight: 800; font-size: 0.78rem;\n    color: #1e293b; letter-spacing: .06em;\n}\n.alugada-chapa:hover { color: #2b6cb0; }\n.alugada-chapa:focus-visible { outline: 2px solid #3182ce; outline-offset: 2px; border-radius: 4px; }\n.alugada-media {\n    display: block; margin-top: 3px;\n    color: #64748b;\n    line-height: 1.35;\n}\n/* Uma linha para os quilómetros, outra para a média. Cada uma inteira, sem se\n   partir a meio de um número — num cartão de 5,4 cm as duas juntas na mesma\n   linha ficavam cortadas à direita. */\n.alugada-parte { display: block; white-space: nowrap; }\n.alugada-sem { color: #94a3b8; font-weight: 600; }\n.alugadas-vazio { margin: 0; text-align: center; color: #94a3b8; }\n/* O abastecimento que ainda não fechou consumo: informação, não alarme. */\n.alugada-solto { color: #b45309; font-size: 0.72rem; line-height: 1.3; }\n\n/* As linhas deixam de ser caixas próprias e os seus dois campos passam a ser\n   itens da grelha de cima. */\n.vehicle-resumo > div { display: contents; }\n/* Duas colunas em vez de flex com espaço no meio: assim as etiquetas encostam\n   todas ao mesmo eixo e os valores ficam centrados na coluna deles. */\n/* O traço separador vai nas células, já que as linhas deixaram de existir\n   como caixa. */\n.vehicle-resumo > div + div > dt,\n.vehicle-resumo > div + div > dd { border-top: 1px solid #f1f5f9; }\n.vehicle-resumo dt, .vehicle-resumo dd { padding: 2px 0; }\n.vehicle-resumo dt { color: #64748b; white-space: nowrap; text-align: right; }\n.vehicle-resumo dd {\n    margin: 0; color: #1e293b; font-weight: 600;\n    text-align: center;\n    /* Sem isto o valor podia partir-se em qualquer letra, e a grelha usava\n       essa liberdade para dar mais largura à coluna das etiquetas: \"16/02/2027\"\n       aparecia em duas linhas com o cartão a 5 cm. Proibida a quebra, é a\n       coluna da etiqueta que cede. */\n    white-space: nowrap;\n}\n\n/* Prazo a um mês ou menos, ou revisão a 2500 km ou menos: fundo vermelho e\n   letra branca. O realce fica no valor e não na célula toda, para se perceber\n   que é aquele dado que está em risco. */\n/* Ocupa a largura toda da coluna do valor: com inline-block, cada etiqueta\n   ficava do tamanho do seu próprio texto e as três apareciam com larguras\n   diferentes umas por baixo das outras. */\n.prazo-alerta {\n    display: block;\n    background: #dc2626; color: #fff;\n    padding: 1px 5px; border-radius: 4px;\n    font-weight: 700;\n    text-align: center;\n}\n\n/* A consulta tem três selectores; o registo de evento tem data, texto e botão. */\n.consulta-form { grid-template-columns: 160px 120px 150px; }\n/* Os campos numa linha e o botão por baixo, ao centro. */\n/* O seletor leva o .modal-kms à frente por necessidade: a regra geral\n   \".modal-content form\" tem mais força do que uma classe sozinha, e era ela que\n   continuava a impor 24px de margem por cima dos campos. */\n.modal-kms .evento-form { padding: 4px 24px 14px; }\n.evento-campos {\n    display: grid;\n    /* Data e valor no mínimo que o seu conteúdo exige — 136px para dd/mm/aaaa\n       com o calendário, 120px para 100.000,00 € — e tudo o que sobra vai para a\n       ocorrência, que é texto livre e nunca tem largura a mais. */\n    grid-template-columns: 136px minmax(200px, 1fr) 120px;\n    gap: 12px;\n    align-items: end;\n}\n.evento-campos .form-group { margin-bottom: 0; }\n.evento-registar {\n    margin: 14px auto 0; min-width: 180px; height: 42px;\n    /* Centragem declarada: com altura fixa e o padding que estes botões trazem,\n       o texto não assentava ao meio sozinho. */\n    display: flex; align-items: center; justify-content: center;\n    padding: 0 16px;\n}\n\n/* Caixa do montante com o símbolo colado à direita, dentro do próprio campo. */\n.campo-euro { position: relative; }\n.campo-euro input { padding-right: 26px !important; text-align: right !important; }\n.campo-euro span {\n    position: absolute; right: 10px; top: 50%; transform: translateY(-50%);\n    color: #64748b; font-size: 0.9rem; pointer-events: none;\n}\n\n/* O valor não deve partir-se nem competir com a descrição pelo espaço. */\n.kms-tabela th.col-valor, .kms-tabela td.col-valor { text-align: right; white-space: nowrap; width: 1%; }\n.modal-kms .form-group select {\n    width: 100%; height: 42px; box-sizing: border-box;\n    padding: 0 10px; border: 1px solid #cbd5e0; border-radius: 8px;\n    font-size: 0.9rem; background: #fff; color: #1e293b;\n}\n.modal-kms .form-group select:disabled { background: #f1f5f9; color: #94a3b8; cursor: not-allowed; }\n/* A data não deve partir-se em duas linhas por causa de um texto comprido ao lado. */\n.kms-tabela td.col-data { white-space: nowrap; width: 1%; }\n\n/* Data ao centro como o seu título; a ocorrência fica à esquerda porque é texto\n   corrido, e o valor à direita para os montantes alinharem pela vírgula. */\n.kms-tabela td.col-data { text-align: center; }\n\n.kms-tabela td.col-acoes { white-space: nowrap; width: 1%; text-align: right; }\n/* O .btn-icon-small é display:flex, o que faz cada botão ocupar a linha toda e\n   empilha o lápis por cima do caixote. Aqui ficam lado a lado. */\n.kms-tabela td.col-acoes .btn-icon-small { display: inline-flex; vertical-align: middle; }\n.kms-tabela td.col-acoes .btn-icon-small + .btn-icon-small { margin-left: 3px; }\n\n/* Caixa de correção do texto, à medida da célula onde nasce. */\n.evento-edicao {\n    width: 100%; box-sizing: border-box;\n    padding: 3px 6px;\n    border: 1px solid #3182ce; border-radius: 5px;\n    font-size: 0.86rem; color: #1e293b;\n}\n\n/* Total do período, na última linha da consulta de eventos. Traço preto a\n   separá-la das restantes, e o texto assente numa etiqueta de vermelho\n   esbatido — o vermelho aqui assinala, não dá alarme. */\n.kms-tabela tfoot .linha-total td {\n    border-top: 2px solid #1e293b;\n    padding-top: 9px;\n    color: #0f172a;\n    font-weight: 700;\n}\n/* O vermelho cobre a linha toda, da primeira célula à última, como um só\n   retângulo com as pontas arredondadas nas extremidades. */\n.kms-tabela tfoot .linha-total td { background: #fee2e2; }\n.kms-tabela tfoot .linha-total td:first-child { border-radius: 6px 0 0 6px; padding-left: 10px; }\n.kms-tabela tfoot .linha-total td:last-child { border-radius: 0 6px 6px 0; padding-right: 10px; }\n.kms-tabela tfoot .linha-total td:nth-child(2) { text-align: left; }\n\n/* Botão de dar o alerta por tratado. Só aparece enquanto houver vermelho, e\n   fica ao lado do valor em vez de numa coluna própria — no cartão estreito não\n   há largura para lhe dar um sítio só dela. */\n.btn-tratado {\n    margin-left: 4px;\n    width: 16px; height: 16px;\n    padding: 0; border: none; border-radius: 4px;\n    background: #16a34a; color: #fff;\n    font-size: 0.6rem; line-height: 1;\n    cursor: pointer; vertical-align: middle;\n}\n.btn-tratado:hover { background: #15803d; }\n.btn-tratado:focus-visible { outline: 2px solid #1d4ed8; outline-offset: 1px; }\n\n\n/* Revisão: quilómetros OU data, o que vier primeiro. O \"ou\" fica entre os dois\n   campos para se perceber que são alternativas e não dois prazos a cumprir. */\n.form-group .revisao-ou {\n    text-align: center; font-size: 11px; font-weight: 700; letter-spacing: 0.06em;\n    text-transform: uppercase; color: #94a3b8; margin: 5px 0 4px;\n}\n\n\n/* No cartão, os dois gatilhos da revisão ficam empilhados: o valor, o \"ou\", e\n   a data. Sem tamanho nem cor próprios — herdam do valor, para a coluna ficar\n   toda com a mesma letra. */\n.vehicle-resumo .revisao-ou-cartao,\n.vehicle-resumo .revisao-data { display: block; }\n\n/* Bomba de abastecimento ao lado da ultima media, quando o consumo se afasta\n   do normal desta viatura. Fica antes do visto, como o vermelho dos prazos. */\n.alerta-consumo { margin-left: 6px; font-size: 0.95rem; line-height: 1; }\n\n/* \"11,20 L/100 km\" nao pode partir-se ao meio. As datas dos outros alertas sao\n   curtas e cabem sempre; este valor e mais largo e, em cartoes estreitos,\n   quebrava a meio do numero. */\n.vehicle-resumo .prazo-alerta { white-space: nowrap; }\n\n.vehicles-loading { min-height: 310px; display: flex; align-items: center; justify-content: center; gap: 16px; color: #577585; border: 1px solid #ffffffb0; border-radius: 18px; background: #f4f9ff80; }\n\n/* Consumos com a mesma tipografia, mantendo a cor que identifica o desvio. */\nhtml body .app-layout .main-content .veiculo-media-valor {\n    font-family: Arial, Helvetica, sans-serif !important;\n    font-size: 13px !important;\n    font-style: normal !important;\n    font-weight: 500 !important;\n    font-variant-numeric: tabular-nums;\n}\nhtml body .app-layout .main-content .veiculo-media-valor.prazo-alerta {\n    background: transparent !important;\n    color: #ff0000 !important;\n    padding: 0;\n}\n\n/* Avisos legíveis e discretos, sem fundos vermelhos. */\nhtml body .app-layout .main-content .vehicle-resumo .prazo-alerta {\n    background: transparent !important;\n    color: #825009 !important;\n    padding: 0;\n    font-weight: 600;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
